"use strict"

const PTCProductBuilder = {
    location: 'ro',
    apiURL: null,
    fetchOptionURL: null,
    embroiderySaveImageURL: null,
    embroideryImagesURL: null,
    embroideryIconsURL: null,
    embroideryItemKeys: ['item-1', 'item-2', 'item-3', 'item-4'],
    storageKey: null,
    loadingSteps: [],
    // Optional cross-sell offer rendered above the add-to-cart button:
    // { title, text, button, price, material, endpoint } — configured per
    // product in the same config JSON as apiURL / relatedProducts.
    upsell: null,
    _orderBusy: false,
    activeCarSettings: {
        'carBrand': true,
        'carModel': true,
        'carSubmodel': true,
        'carSubmodelVariation': false,
        'carFixingSystem': false
    },
    activeSettings: {
        'baseColor': true,
        'borderColor': true,
        'borderType': false,
        'threadType': true,
        'threadColor': true,
        'reinforcement': true,
        'configuration': true,
        'embroidery': false,
        'houseType': false
    },
    invisibleSettingsCheckout: [
        'carFixingSystem',
        'reinforcement',
        'configuration',
        'embroidery',
        'houseType'
    ],
    currentSettings: {
        'version': '1.3.0',
        'baseColor': 'black',
        'borderColor': 'black',
        'borderType': 'piele',
        'threadType': 'simple',
        'threadColor': 'black',
        'reinforcement': 'no',
        'configuration': 'full',
        'embroidery': 'no'
    },
    embroiderySettings: {
        itemActions: {},
        currentPositions: {}
    },
    colorHexMappings: {
        'black': '#000',
        'grey': '#a1a1a1',
        'beige': '#d5c0a9',
        'blue': '#0091f7',
        'purple': '#7925c7',
        'yellow': '#f7cd28',
        'white': '#fff',
        'magenta': '#ffb2ff',
        'red': '#ff0000',
        'orange': '#f7761c',
        'burgundy': '#762b2d',
        'darkBrown': '#45342c',
        'lightBrown': '#834c33'
    },
    carSettings: {
        carBrand: null,
        carModel: null,
        carSubmodel: null,
        carSubmodelVariation: null,
        carFixingSystem: null
    },
    mappings: {
        colors: {
            'black': 'Negru',
            'graphite-grey': 'Gri grafit',
            'grey': 'Gri',
            'beige': 'Bej',
            'blue': 'Albastru',
            'purple': 'Mov',
            'yellow': 'Galben',
            'white': 'Alb',
            'magenta': 'Ciclam',
            'red': 'Rosu',
            'orange': 'Portocaliu',
            'burgundy': 'Grena',
            'darkBrown': 'Maro inchis',
            'lightBrown': 'Maro deschis'
        },
        configurations: {
            'trunk': 'Portbagaj',
            'full-with-trunk': 'Fata, spate si portbagaj',
            'full': 'Fata si spate',
            'front': 'Fata'
        },
        threadTypes: {
            'simple': 'Simpla',
            'double': 'Dubla'
        },
        borderTypes: {
            'piele': 'Piele',
            'surfilare': 'Surfilare'
        },
        yesNo: {
            'no': 'Nu',
            'yes': 'Da'
        },
        'houseTypes': {
            'exterior': 'Exterior',
            'interior': 'Interior',
        }
    },
    images: {},
    prices: {},
    baseTitle: '',
    optionTextValueMappings: {
        'baseColor': 'colors',
        'borderColor': 'colors',
        'borderType': 'borderTypes',
        'configuration': 'configurations',
        'threadType': 'threadTypes',
        'threadColor': 'colors',
        'reinforcement': 'yesNo',
        'embroidery': 'yesNo',
        'houseType': 'houseTypes'
    },
    newOdooMappings: {
        'car_mat_color': {
            values: {
                'grey': 'gri',
                'red': 'rosu'
            }
        },
        'car_mat_edge_color': {
            values: {
                'grey': 'gri',
            }
        },
        'thread_color': {
            values: {
                'grey': 'gri',
            }
        }
    },
    odooMappings: {
        'baseColor': {
            id: 2,
            name: 'Culoare baza',
            values: {
                'black': 'negru',
                'grey': 'gri',
                'beige': 'bej',
                'burgundy': 'grena',
                'red': 'rosu',
                'darkBrown': 'maro inchis',
                'lightBrown': 'maro deschis'
            }
        },
        'borderColor': {
            id: 4,
            name: 'Culoare margine PIELE',
            values: {
                'black': 'negru',
                'blue': 'albastru',
                'purple': 'mov',
                'yellow': 'galben',
                'white': 'alb',
                'magenta': 'roz',
                'grey': 'gri',
                'red': 'rosu',
                'orange': 'portocaliu',
                'beige': 'bej',
            }
        },
        'threadType': {
            id: 14,
            name: 'Tip ata',
            values: {
                'simple': 'simpla',
                'double': 'dubla'
            }
        },
        'threadColor': {
            id: 3,
            name: 'Culoare ata',
            values: {
                'black': 'negru',
                'blue': 'albastru',
                'purple': 'mov',
                'yellow': 'galben',
                'white': 'alb',
                'magenta': 'roz',
                'grey': 'gri',
                'red': 'rosu',
                'orange': 'portocaliu',
                'beige': 'bej',
            }
        },
        'reinforcement': {
            id: 15,
            name: 'Intaritura calcai sofer',
            values: {
                'no': 'nu',
                'yes': 'da'
            }
        },
    },
    submodelVariationDescriptions: {},
    submodelsFixingSystems: {},
    translations: {},
    disableBaseColors: [],
    disableThreadTypes: [],
    borderTypeColorRestrictions: {},
    getOptionLabel: [
        'carBrand',
        'carModel',
        'carSubmodel',
        'carSubmodelVariation',
    ],
    material: null,
    _ignorePromotions: false,
    init: async function (config = {}) {
        this.applyConfig(config);
        this.addListeners();
        if (this.storage.hasSettings()) {
            this.currentSettings = this.storage.getSettings();
            await this.updateOptionsBySettings();
        } else {
            this.initExtraCurrentSettings();
            this.updateImages();
        }
        if (this.isActiveSetting('embroidery')) {
            this.embroideryBuilder.init();
        }
        this.hideSectionBySettings();
        this.hideDisabledBaseColors();
        this.hideDisabledThreadTypes();
        this.applyBorderTypeColorRestrictions();
        this.updateOptionPriceBadges();

        //to remove after testing
        if (this.storageKey === 'PTCProductBuilderTest') {
            const carFixingSystemWrapper = document.getElementById('carFixingSystemWrapper');
            if (carFixingSystemWrapper) {
                carFixingSystemWrapper.style.display = 'block';
            }
        }

        // The submodel-variation select stays hidden until a submodel that
        // actually has variations is chosen (see refreshCarSubmodelVariationVisibility).
        this.refreshCarSubmodelVariationVisibility();

        await this.preloadImages();
    },
    applyConfig: function (config) {
        const configKeys = [
            'apiURL',
            'fetchOptionURL',
            'embroiderySaveImageURL',
            'embroideryImagesURL',
            'embroideryIconsURL',
            'storageKey',
            'images',
            'prices',
            'activeCarSettings',
            'activeSettings',
            'baseTitle',
            'embroideryItemKeys',
            'translations',
            'location',
            'disableBaseColors',
            'disableThreadTypes',
            'borderTypeColorRestrictions',
            'material',
            'loadingSteps',
            'upsell'
        ];
        for (const key of configKeys) {
            if (config.hasOwnProperty(key)) {
                this[key] = config[key];
            }
        }
    },
    initExtraCurrentSettings: function () {
        if(this.isActiveSetting('houseType')) {
            this.currentSettings.houseType = 'exterior';
        }
    },
    hideSectionBySettings: function () {
        const inactiveSettings = Object.keys(this.activeSettings).filter(key => this.activeSettings[key] === false);
        for (const setting of inactiveSettings) {
            const section = document.getElementById(setting + 'Wrapper');
            if (section) section.remove();
        }
    },
    hideDisabledBaseColors: function () {
        if (!Array.isArray(this.disableBaseColors) || this.disableBaseColors.length === 0) return;
        const baseColorOptions = document.querySelectorAll('#baseColor .option-value.color');
        baseColorOptions.forEach(option => {
            const input = option.querySelector('input[type="radio"]');
            if (input && this.disableBaseColors.includes(input.value)) {
                option.remove();
            }
        });
    },
    hideDisabledThreadTypes: function () {
        if (!Array.isArray(this.disableThreadTypes) || this.disableThreadTypes.length === 0) return;
        const threadTypeOptions = document.querySelectorAll('#threadType .option-value');
        threadTypeOptions.forEach(option => {
            const input = option.querySelector('input[type="radio"]');
            if (input && this.disableThreadTypes.includes(input.value)) {
                option.remove();
            }
        });
        if (this.disableThreadTypes.includes(this.currentSettings.threadType)) {
            const firstRemaining = document.querySelector('input[name="threadType"]');
            if (firstRemaining) {
                firstRemaining.checked = true;
                this.currentSettings.threadType = firstRemaining.value;
            }
        }
    },
    applyBorderTypeColorRestrictions: function () {
        if (!this.isActiveSetting('borderType') || !this.isActiveSetting('borderColor')) return;
        const restrictions = this.borderTypeColorRestrictions ?? {};
        const allowedColors = restrictions[this.currentSettings.borderType] ?? null;
        const options = document.querySelectorAll('#borderColor .option-value.color');
        options.forEach(option => {
            const input = option.querySelector('input[type="radio"]');
            if (!input) return;
            const isAllowed = allowedColors === null || allowedColors.includes(input.value);
            option.style.display = isAllowed ? '' : 'none';
        });
        if (allowedColors !== null && !allowedColors.includes(this.currentSettings.borderColor)) {
            const fallbackColor = allowedColors[0];
            const fallbackInput = document.querySelector(`#borderColor input[name="borderColor"][value="${fallbackColor}"]`);
            if (fallbackInput) {
                fallbackInput.checked = true;
                this.updateSetting('borderColor', fallbackColor);
                this.setOptionTextValue('borderColor', fallbackColor);
            }
        }
    },
    addListeners: function () {
        if (this.isActiveSetting('baseColor')) {
            document.querySelectorAll('input[name="baseColor"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }
        if (this.isActiveSetting('borderColor')) {
            document.querySelectorAll('input[name="borderColor"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }
        if (this.isActiveSetting('borderType')) {
            document.querySelectorAll('input[name="borderType"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }
        if (this.isActiveSetting('threadType')) {
            document.querySelectorAll('input[name="threadType"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }
        if (this.isActiveSetting('threadColor')) {
            document.querySelectorAll('input[name="threadColor"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }
        if (this.isActiveSetting('reinforcement')) {
            document.querySelectorAll('input[name="reinforcement"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }
        if (this.isActiveSetting('configuration')) {
            document.querySelectorAll('input[name="configuration"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }
        if (this.isActiveSetting('embroidery')) {
            document.querySelectorAll('input[name="embroidery"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
                input.addEventListener('input', this.toggleEmbroideryBuilder);
            });
        }
        if (this.isActiveSetting('houseType')) {
            document.querySelectorAll('input[name="houseType"]').forEach(input => {
                input.addEventListener('input', this.changeOption);
            });
        }

        if (this.isActiveCarSetting('carBrand')) {
            document.getElementById('carBrand').addEventListener('change', this.changeBrand);
        }
        if (this.isActiveCarSetting('carModel')) {
            document.getElementById('carModel').addEventListener('change', this.changeModel);
        }
        if (this.isActiveCarSetting('carSubmodel')) {
            document.getElementById('carSubmodel').addEventListener('change', this.changeSubmodel);
        }
        if (this.isActiveCarSetting('carSubmodelVariation')) {
            document.getElementById('carSubmodelVariation').addEventListener('change', this.changeSubmodelVariation);
        }
        if (this.isActiveCarSetting('carFixingSystem')) {
            document.getElementById('carFixingSystem').addEventListener('change', this.changeFixingSystem);
        }

        document.getElementById('submitProductBuilder').addEventListener('click', this.submit);
    },
    changeOption: function () {
        PTCProductBuilder.updateSetting(this.name, this.value);
        PTCProductBuilder.setOptionTextValue(this.name, this.value);
    },
    toggleEmbroideryBuilder: function (value = null) {
        const embroideryBuilderEl = document.getElementById('embroideryBuilder');
        if (value === 'block' || value === 'none') {
            embroideryBuilderEl.style.display = value;
        } else {
            embroideryBuilderEl.style.display = this.value === 'yes' ? 'block' : 'none';
        }
        if (embroideryBuilderEl.style.display === 'block') {
            new Glide('#embroideryImages').mount()
        }
    },
    setOptionTextValue: function (optionKey, value) {
        if (['_odoo_attributes', 'version'].includes(optionKey)) return;
        const optionEl = document.getElementById(optionKey);
        if (!optionEl) return; // option not rendered on this page — skip it
        const titleText = optionEl.querySelector('.value');
        if (titleText) {
            const key = this.optionTextValueMappings[optionKey];
            const text = this.mappings[key]?.[value] ?? value;
            titleText.innerText = this.getTranslatedText(value, text);
        }
    },
    updateSetting: function (key, value) {
        this.currentSettings[key] = value;
        this.storage.saveSettings(this.currentSettings);
        if (key === 'borderType') {
            this.applyBorderTypeColorRestrictions();
        }
        this.updateImages();
        this.updatePrice();
        this.updateOptionPriceBadges();
        if (this.isActiveSetting('embroidery')) {
            this.embroideryBuilder.updateCanvasByCurrentSettings();
        }
        if (key === 'baseColor' || key === 'borderColor') {
            // Preload the newly selected color combo's preview images on demand
            this.preloadImageCombo(`${this.currentSettings.baseColor}-${this.currentSettings.borderColor}`);
        }
    },
    updateCarSettings: function (name, value) {
        this.currentSettings[name] = value;
        this.storage.saveSettings(this.currentSettings);
    },
    updateOptionsBySettings: async function () {
        for (const setting in this.currentSettings) {
            if (!this.isActiveSetting(setting) && !this.isActiveCarSetting(setting)) continue;
            const value = this.currentSettings[setting];
            if (setting === 'carBrand' || setting === 'carModel' || setting === 'carSubmodel' || setting === 'carSubmodelVariation' || setting === 'carFixingSystem') {
                if (this.isActiveCarSetting(setting)) {
                    this.carSettings[setting] = value;
                    const el = document.querySelector(`#${setting} option[value='${value}']`);
                    if (el) el.selected = true;
                    await this.updateCarSelect(setting);
                }
            } else {
                const el = document.querySelector(`input[name="${setting}"][value="${value}"]`);
                if (el) el.checked = true;
            }
            this.setOptionTextValue(setting, value);
        }
        if (this.isActiveSetting('embroidery')) {
            if (this.currentSettings.embroidery === 'yes') {
                this.toggleEmbroideryBuilder('block');
            } else {
                this.toggleEmbroideryBuilder('none');
            }
        }
        this.updateImages();
        this.updatePrice();
    },

    isVideo: function (src) {
        return /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(src);
    },
    getOrCreateVideoEl: function (imgId) {
        const videoId = imgId + 'Video';
        let video = document.getElementById(videoId);
        if (!video) {
            const img = document.getElementById(imgId);
            video = document.createElement('video');
            video.id = videoId;
            video.autoplay = true;
            video.loop = true;
            video.muted = true;
            video.playsInline = true;
            video.style.display = 'none';
            if (img.getAttribute('width')) video.setAttribute('width', img.getAttribute('width'));
            if (img.getAttribute('height')) video.setAttribute('height', img.getAttribute('height'));
            img.parentNode.insertBefore(video, img.nextSibling);
        }
        return video;
    },
    updateMediaSlot: function (id, src) {
        const img = document.getElementById(id);
        if (!img) return;
        const validSrc = src && src !== '#';
        if (!validSrc) {
            img.style.display = 'none';
            const video = document.getElementById(id + 'Video');
            if (video) video.style.display = 'none';
            return;
        }
        if (this.isVideo(src)) {
            img.style.display = 'none';
            const video = this.getOrCreateVideoEl(id);
            if (video.getAttribute('data-src') !== src) {
                video.setAttribute('data-src', src);
                video.src = src;
                video.load();
            }
            video.style.display = 'block';
        } else {
            const resized = this.resizeImage(src, '_450x450_crop_center');
            img.style.display = 'block';
            img.src = resized;
            // original full-size source — used by the gallery zoom/viewer
            img.dataset.fullSrc = src;
            const video = document.getElementById(id + 'Video');
            if (video) video.style.display = 'none';
        }
    },
    updateImages: function () {
        const settings = this.currentSettings;
        const images = this.images[`${settings.baseColor}-${settings.borderColor}`] ?? false;
        if (!images) return;

        // On small screens the product images are shown by the v2 gallery
        // slider (v2_product_gallery snippet, #mobileBuilderGallery) instead
        // of the desktop media slots — nothing gets fetched or autoplayed
        // for the hidden desktop slots, which saves a lot on mobile
        // (videos only load when the user actually plays them).
        const galleryEl = document.getElementById('mobileBuilderGallery');
        if (galleryEl && window.matchMedia('(max-width: 63.9375em)').matches) {
            this.updateMobileGallery(galleryEl, images);
            return;
        }

        this.updateMediaSlot('firstImage', images.firstImage);
        this.updateMediaSlot('secondImage', images.secondImage);
        this.updateMediaSlot('thirdImage', images.thirdImage);
        this.updateMediaSlot('fourthImage', images.fourthImage);
        this.updateMediaSlot('fifthImage', images.fifthImage);
        this.updateMediaSlot('sixthImage', images.sixthImage);
        this.updateMediaSlot('seventhImage', images.seventhImage);
    },
    updateMobileGallery: function (galleryEl, imageSet) {
        const comboKey = `${this.currentSettings.baseColor}-${this.currentSettings.borderColor}`;
        if (galleryEl.dataset.combo === comboKey) return; // already showing this combo

        // Tear down the ProductGallery instance of the previous combo
        if (galleryEl.pgInstance) {
            try { galleryEl.pgInstance.destroy(); } catch (error) {}
            galleryEl.pgInstance = null;
        }

        const html = this.buildMobileGalleryHtml(imageSet);
        if (!html) return;
        galleryEl.dataset.combo = comboKey;
        galleryEl.innerHTML = html;
        if (typeof ProductGallery !== 'undefined') {
            galleryEl.pgInstance = new ProductGallery(galleryEl);
        }
    },
    buildMobileGalleryHtml: function (imageSet) {
        // Mirrors the v2_product_gallery_builder snippet structure so the
        // ProductGallery code can drive rebuilt slides exactly like the
        // server-rendered ones.
        const keys = ['firstImage', 'secondImage', 'thirdImage', 'fourthImage', 'fifthImage', 'sixthImage', 'seventhImage'];
        const slides = [];
        keys.forEach((key) => {
            const url = imageSet[key];
            if (!url || url === '#') return;
            const isVideo = this.isVideo(url);
            const media = isVideo
                ? '<video class="pg-media" muted loop playsinline preload="none" data-src="' + url + '" width="1080" height="1080"></video>' +
                  '<button class="pg-play-btn" type="button" aria-label="Play video"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg></button>'
                : '<img class="pg-media"' + (this.gallerySrcset(url) ? ' data-srcset="' + this.gallerySrcset(url) + '"' : '') + ' data-src="' + this.resizeCdnImage(url, 480) + '" sizes="(min-width: 640px) 50vw, 100vw" alt="" width="1080" height="1080">';
            slides.push(
                '<div class="pg-slide" data-type="' + (isVideo ? 'video' : 'image') + '" role="tabpanel" aria-roledescription="slide"' +
                (slides.length ? ' inert' : '') + '>' + media + '</div>'
            );
        });
        if (!slides.length) return '';

        const count = slides.length;
        const arrows = count > 1
            ? '<button class="pg-arrow pg-arrow--prev" type="button" aria-label="Slide anterioara"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
              '<button class="pg-arrow pg-arrow--next" type="button" aria-label="Slide urmatoarea"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
            : '';
        let dots = '';
        if (count > 1) {
            dots = '<div class="pg-dots" role="tablist" aria-label="Slides">';
            for (let i = 0; i < count; i++) {
                dots += '<button class="pg-dot" type="button" role="tab" aria-label="Slide ' + (i + 1) + '"' +
                        (i === 0 ? ' aria-selected="true"' : ' aria-selected="false"') +
                        ' data-index="' + i + '"></button>';
            }
            dots += '</div><div class="pg-progress" aria-hidden="true"></div>';
        }
        return '<div class="pg-viewer"><div class="pg-track">' + slides.join('') + '</div>' + arrows + dots + '</div>';
    },
    updatePrice: function () {
        const {price, regularPrice} = this.getPriceByCurrentSettings();
        const priceEl = document.getElementById('price');
        const priceValue = priceEl.getElementsByTagName('span');

        priceValue[0].innerText = this.formatPrice(price);

        const regularPriceEl = document.getElementById('regularPrice');
        if (regularPriceEl) {
            const regularPriceValue = regularPriceEl.getElementsByTagName('span');
            regularPriceValue[0].innerText = this.formatPrice(regularPrice);
            regularPriceEl.style.display = price === regularPrice ? 'none' : 'inline-block';
        }
    },
    getBorderTypeExtraCost: function () {
        if (!this.isActiveSetting('borderType')) return 0;
        const borderTypePrices = this.prices.borderType ?? {};
        return Number(borderTypePrices[this.currentSettings.borderType] ?? 0);
    },
    getOptionExtraCost: function (optionName) {
        const currentValue = this.currentSettings[optionName];
        const standardValues = {
            borderColor: this.currentSettings.baseColor,
            borderType: 'piele',
            threadType: 'simple',
            threadColor: this.currentSettings.baseColor
        };
        const standardValue = standardValues[optionName];
        if (standardValue === undefined || currentValue === standardValue) return 0;

        const {price: currentPrice} = this.getPriceByCurrentSettings();
        this.currentSettings[optionName] = standardValue;
        const {price: standardPrice} = this.getPriceByCurrentSettings();
        this.currentSettings[optionName] = currentValue;

        return currentPrice - standardPrice;
    },
    isOptionPromotion: function (optionName) {
        if (this._ignorePromotions) return false;
        return Boolean(this.prices?.promotions?.[optionName]);
    },
    getOptionNominalCost: function (optionName) {
        this._ignorePromotions = true;
        const cost = this.getOptionExtraCost(optionName);
        this._ignorePromotions = false;
        return cost;
    },
    updateOptionPriceBadges: function () {
        const priceOptions = ['borderColor', 'borderType', 'threadType', 'threadColor'];
        for (const optionName of priceOptions) {
            const container = document.getElementById(optionName);
            if (!container) continue;
            const titleEl = container.querySelector('.option-title');
            if (!titleEl) continue;
            let badge = titleEl.querySelector('.option-price-badge');
            if (!badge) {
                badge = document.createElement('span');
                badge.className = 'option-price-badge';
                titleEl.appendChild(badge);
            }
            const delta = this.getOptionExtraCost(optionName);
            const nominalDelta = this.getOptionNominalCost(optionName);
            const isPromo = this.isOptionPromotion(optionName) && nominalDelta > 0;

            if (isPromo) {
                const nomAbs = Math.abs(nominalDelta);
                const nomFormatted = Number.isInteger(nomAbs) ? nomAbs.toString() : nomAbs.toFixed(2).replace('.', ',');
                badge.innerHTML = `<s class="promo-original">+${nomFormatted} lei</s> +0 lei`;
                badge.setAttribute('data-sign', 'zero');
            } else {
                const prefix = delta > 0 ? '+' : delta < 0 ? '-' : '+';
                const abs = Math.abs(delta);
                const formatted = Number.isInteger(abs) ? abs.toString() : abs.toFixed(2).replace('.', ',');
                badge.textContent = `${prefix}${formatted} lei`;
                badge.setAttribute('data-sign', delta > 0 ? 'positive' : delta < 0 ? 'negative' : 'zero');
            }
        }
    },
    formatPrice: function (num) {
        return new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num ?? 0);
    },
    getPriceByCurrentSettings: function () {
        let price;
        let regularPrice;
        if (this.isStandardPrice()) {
            price = Number(this.prices.basePrice);
            regularPrice = this.prices?.regularPrice ? Number(this.prices.regularPrice) : price;
        } else {
            const standardPriceDiff = this.getStandardPriceDiff();
            price = Number(this.prices.basePrice);
            for (const diff of standardPriceDiff) {
                if (this.isOptionPromotion(diff)) continue;
                if (diff === 'threadType') {
                    price += Number(this.prices.threadType[this.currentSettings.threadType])
                } else if (diff === 'houseType') {
                    price += Number(this.prices.houseType[this.currentSettings.houseType])
                } else {
                    price += Number(this.prices[diff])
                }
            }
        }
        const borderTypePrice = this.getBorderTypeExtraCost();
        if (borderTypePrice > 0) {
            price += borderTypePrice;
            if (regularPrice !== undefined) regularPrice += borderTypePrice;
        }
        if (PTCProductBuilder.currentSettings.embroidery === 'yes') {
            const embroideryPrice = this.getEmbroideryPriceBySettings();
            price = price + embroideryPrice;
            if(embroideryPrice > 0) regularPrice = null;
        }
        regularPrice = regularPrice ?? price;
        return {price, regularPrice};
    },
    getEmbroideryPriceBySettings: function () {
        const itemActions = this.embroiderySettings.itemActions;
        let embroideryElsCount = 0;
        for (const item in itemActions) {
            const itemEls = Object.keys(itemActions[item]['page']);
            embroideryElsCount = embroideryElsCount + itemEls.length;
        }
        return this.prices.embroidery[embroideryElsCount] ?? 0;
    },
    isStandardPrice: function () {
        return Boolean(this.prices.standard.find(obj => {
            for (const key in this.currentSettings) {
                if (['carBrand', 'carModel', 'carSubmodel', 'carSubmodelVariation', 'carFixingSystem', 'embroidery', 'borderType', '_odoo_attributes', 'version'].includes(key)) continue;
                if (!this.isActiveSetting(key)) continue;
                if (this.currentSettings.hasOwnProperty(key) && this.currentSettings[key] !== obj[key]) {
                    return false;
                }
            }
            return true;
        }));
    },
    getStandardPriceDiff: function () {
        let diff = [];
        for (const standardPrice of this.prices.standard) {
            if(this.currentSettings.baseColor !== standardPrice.baseColor) continue;
            const currentDiff = [];
            for (const key in this.currentSettings) {
                if (['carBrand', 'carModel', 'carSubmodel', 'carSubmodelVariation', 'carFixingSystem', 'embroidery', 'borderType', '_odoo_attributes', 'version'].includes(key)) continue;
                if (this.currentSettings.hasOwnProperty(key) && this.currentSettings[key] !== standardPrice[key]) {
                    if (!this.isActiveSetting(key)) continue;
                    currentDiff.push(key);
                }
            }
            if (diff.length === 0 || currentDiff.length < diff.length) {
                diff = currentDiff;
            }
        }
        return diff;
    },
    changeBrand: async function () {
        PTCProductBuilder.carSettings.carBrand = this.value;
        PTCProductBuilder.carSettings.carModel = null;
        PTCProductBuilder.carSettings.carSubmodel = null;
        PTCProductBuilder.carSettings.carSubmodelVariation = null;
        PTCProductBuilder.carSettings.carFixingSystem = null;
        await PTCProductBuilder.updateCarSelect('carBrand');
        PTCProductBuilder.updateCarSettings(this.name, this.value);
    },
    changeModel: async function () {
        PTCProductBuilder.carSettings.carModel = this.value;
        PTCProductBuilder.carSettings.carSubmodel = null;
        PTCProductBuilder.carSettings.carSubmodelVariation = null;
        PTCProductBuilder.carSettings.carFixingSystem = null;
        await PTCProductBuilder.updateCarSelect('carModel');
        PTCProductBuilder.updateCarSettings(this.name, this.value);
    },
    changeSubmodel: async function () {
        PTCProductBuilder.carSettings.carSubmodel = this.value;
        PTCProductBuilder.carSettings.carSubmodelVariation = null;
        PTCProductBuilder.carSettings.carFixingSystem = null;
        await PTCProductBuilder.updateCarSelect('carSubmodel');
        PTCProductBuilder.updateCarSettings(this.name, this.value);
    },
    changeSubmodelVariation: async function () {
        PTCProductBuilder.carSettings.carSubmodelVariation = this.value;
        await PTCProductBuilder.updateCarSelect('carSubmodelVariation');
        PTCProductBuilder.updateCarSettings(this.name, this.value);
        PTCProductBuilder.setSubmodelVariationDescription(this.value);
    },
    changeFixingSystem: function () {
        PTCProductBuilder.carSettings.carFixingSystem = this.value;
        PTCProductBuilder.updateCarSettings(this.name, this.value);
    },
    refreshCarSubmodelVariationVisibility: function () {
        // The variation select is only meaningful once a submodel with
        // variations was chosen. When there are no variations we hide not
        // just the select, but its whole grid column (and the description
        // row underneath) — otherwise an empty column would be left behind.
        const variationSelect = document.getElementById('carSubmodelVariation');
        if (!variationSelect) return;

        const hasOptions = variationSelect.options.length > 1; // > the blank placeholder
        const hasSavedValue = !!this.carSettings.carSubmodelVariation;
        const visible = hasOptions || hasSavedValue;

        variationSelect.style.display = visible ? 'block' : 'none';

        const wrapper = variationSelect.closest('.c') || variationSelect.parentElement;
        if (wrapper) wrapper.style.display = visible ? 'block' : 'none';

        const description = document.getElementById('carSubmodelVariationDescription');
        if (description) {
            const descWrapper = description.closest('.c') || description.parentElement;
            if (descWrapper) descWrapper.style.display = visible ? 'block' : 'none';
        }
    },
    updateCarSelect: async function (type) {
        const modelSelect = document.getElementById('carModel');
        const submodelSelect = document.getElementById('carSubmodel');
        const submodelVariationSelect = document.getElementById('carSubmodelVariation');
        const titleEl = document.getElementById('productTitle');

        if (titleEl) titleEl.innerText = '';

        if (type === 'carBrand') {
            this.setBlankOptionCarModelSelect();
            this.setBlankOptionCarSubmodelSelect();
            if (this.isActiveCarSetting('carSubmodelVariation')) {
                this.setBlankOptionCarSubmodelVariationSelect();
            }
            if (this.isActiveCarSetting('carFixingSystem')) {
                this.setBlankOptionCarFixingSystemSelect();
            }
            this.submodelsFixingSystems = {};
            this.refreshCarSubmodelVariationVisibility();
        }
        if (type === 'carModel') {
            this.setBlankOptionCarSubmodelSelect();
            if (this.isActiveCarSetting('carSubmodelVariation')) {
                this.setBlankOptionCarSubmodelVariationSelect();
            }
            if (this.isActiveCarSetting('carFixingSystem')) {
                this.setBlankOptionCarFixingSystemSelect();
            }
            this.submodelsFixingSystems = {};
            this.refreshCarSubmodelVariationVisibility();
        }
        if (type === 'carSubmodel') {
            if (titleEl) titleEl.innerText = this.getProcessedTitleByCurrentSettings();

            if (this.isActiveCarSetting('carSubmodelVariation')) {
                this.setBlankOptionCarSubmodelVariationSelect();
            }
            if (this.isActiveCarSetting('carFixingSystem')) {
                this.setBlankOptionCarFixingSystemSelect();
            }
        }

        if (type === 'carBrand' || type === 'carModel' || type === 'carSubmodel') {
            if (type === 'carSubmodel') {
                if(this.isActiveCarSetting('carFixingSystem')) {
                    this.setFixingSystemOptions();
                }
                if(!this.isActiveCarSetting('carSubmodelVariation')) return;
            }

            const options = await PTCProductBuilder.getCarOptions();

            if (type === 'carSubmodel') {
                if (options.length === 0) {
                    this.carSettings.carSubmodelVariation = null;
                    this.activeCarSettings.carSubmodelVariation = false;
                } else {
                    this.activeCarSettings.carSubmodelVariation = true;
                }
                submodelVariationSelect.style.display = options.length === 0 ? 'none' : 'block'
            }

            options.forEach(item => {
                const option = document.createElement('option');
                option.value = item.id;
                option.textContent = item.name;
                if (item.hasOwnProperty('description')) {
                    PTCProductBuilder.submodelVariationDescriptions[item.id] = item.description;
                }
                if (item.hasOwnProperty('fixing_systems')) {
                    PTCProductBuilder.submodelsFixingSystems[item.id] = item.fixing_systems;
                }
                switch (type) {
                    case "carBrand":
                        modelSelect.appendChild(option);
                        break;
                    case "carModel":
                        submodelSelect.appendChild(option);
                        break;
                    case "carSubmodel":
                        if (this.isActiveCarSetting('carSubmodelVariation')) {
                            submodelVariationSelect.appendChild(option);
                        }
                        break;
                }
            });
        }
        this.refreshCarSubmodelVariationVisibility();
    },
    setBlankOptionCarModelSelect: function () {
        const modelSelect = document.getElementById('carModel');
        if (!modelSelect) {
            console.error("Element for carModel not found, cannot set blank option");
            return;
        }
        const modelBlankOption = document.createElement('option');
        modelBlankOption.textContent = PTCProductBuilder.getTranslatedText('chooseModel', 'Selecteaza model');

        modelSelect.innerHTML = '';
        modelSelect.appendChild(modelBlankOption);
    },
    setBlankOptionCarSubmodelSelect: function () {
        const submodelSelect = document.getElementById('carSubmodel');
        if (!submodelSelect) {
            console.error("Element for carSubmodel not found, cannot set blank option");
            return;
        }
        const submodelBlankOption = document.createElement('option');
        submodelBlankOption.textContent = PTCProductBuilder.getTranslatedText('chooseGeneration', 'Selecteaza generatia');
        submodelSelect.innerHTML = '';
        submodelSelect.appendChild(submodelBlankOption);
    },
    setBlankOptionCarSubmodelVariationSelect: function () {
        const submodelVariationSelect = document.getElementById('carSubmodelVariation');
        if (!submodelVariationSelect) {
            console.error("Element for carSubmodelVariation not found, cannot set blank option");
            return;
        }

        const submodelTrunkBlankOption = document.createElement('option');
        submodelTrunkBlankOption.textContent = PTCProductBuilder.getTranslatedText('chooseVariation', 'Selecteaza variatie');
        submodelVariationSelect.innerHTML = '';
        submodelVariationSelect.appendChild(submodelTrunkBlankOption);
        PTCProductBuilder.submodelVariationDescriptions = {};
        PTCProductBuilder.setSubmodelVariationDescription();
    },
    setBlankOptionCarFixingSystemSelect: function () {
        const fixingSystemSelect = document.getElementById('carFixingSystem');
        if (!fixingSystemSelect) {
            console.error("Element for carFixingSystem not found, cannot set blank option");
            return;
        }

        const fixingSystemBlankOption = document.createElement('option');
        fixingSystemBlankOption.textContent = PTCProductBuilder.getTranslatedText('chooseFixingSystem', 'Selecteaza sistemul de prindere');
        fixingSystemSelect.innerHTML = '';
        fixingSystemSelect.appendChild(fixingSystemBlankOption);
    },
    setFixingSystemOptions: function () {
        const fixingSystemSelect = document.getElementById('carFixingSystem');
        if (!fixingSystemSelect) {
            console.error("Element for carFixingSystem not found, cannot set fixing system options");
            return;
        }

        fixingSystemSelect.innerHTML = '';
        const fixingSystems = this.submodelsFixingSystems[this.carSettings.carSubmodel] ?? {};
        const keys = Object.keys(fixingSystems);
        if (keys.length > 1) {
            const defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.textContent = 'Alege sistemul de prindere';
            fixingSystemSelect.appendChild(defaultOption);
        }
        for (const key of keys) {
            const option = document.createElement('option');
            option.value = key;
            if (key === 'fara') {
                option.textContent = 'Fara sistem de prindere';
            } else {
                option.textContent = 'Sistem de prindere: ' + key;
            }
            fixingSystemSelect.appendChild(option);
        }
        if (keys.length === 1) {
            fixingSystemSelect.options[0].selected = true;
            fixingSystemSelect.dispatchEvent(new Event('change'));
        }
    },
    getSelectedOption: function (id) {
        const selectElement = document.getElementById(id);
        const selectedIndex = selectElement.selectedIndex ?? null;
        return selectedIndex ? selectElement.options[selectedIndex].text : null;
    },
    getCheckedRadioValue: function getCheckedRadioValue(containerId) {
        const container = document.getElementById(containerId);
        if (!container) return null;
        const radios = container.querySelectorAll('input[type="radio"]');
        for (let i = 0; i < radios.length; i++) {
            if (radios[i].checked) {
                return radios[i].value;
            }
        }
        return null;
    },
    getCheckedRadioOptionText: function getCheckedRadioValue(containerId) {
        const container = document.getElementById(containerId);
        if (!container) return null;
        const radios = container.querySelectorAll('input[type="radio"]');
        for (let i = 0; i < radios.length; i++) {
            if (radios[i].checked) {
                return radios[i].parentElement.querySelector('.box-text').innerText
            }
        }
        return null;
    },
    getCarOptions: async function () {
        const urlParams = new URLSearchParams();
        urlParams.append('type', this.storageKey);
        urlParams.append('location', this.location);
        for (const key in this.carSettings) {
            if (this.carSettings[key] !== null) {
                urlParams.append(key, this.carSettings[key]);
            }
        }
        const urlParamsStr = urlParams.toString();
        if (urlParamsStr.length === 0) return [];
        const url = `${this.fetchOptionURL}?${urlParamsStr}`;
        return await this.fetchData(url);
    },
    fetchData: async function (url) {
        try {
            const response = await fetch(url);
            if (!response.ok) return [];
            return await response.json();
        } catch (error) {
            return [];
        }
    },
    getProcessedTitleByCurrentSettings: function () {
        const baseTitle = this.baseTitle;
        let brand = '';
        let submodel = '';
        if (this.isActiveCarSetting('carBrand')) {
            brand = this.getSelectedOption('carBrand');
        }
        if (this.isActiveCarSetting('carSubmodel')) {
            submodel = this.getSelectedOption('carSubmodel');
        }
        return `${baseTitle} ${brand} ${submodel}`;
    },
    preloadImages: async function () {
        // When the compact gallery (v2_product_gallery snippet) is the active
        // product media — on every breakpoint of the v3 steps template, and
        // on small screens anywhere — it lazy-loads its own media, so
        // preloading the desktop combo crops here would only waste bandwidth.
        const galleryEl = document.getElementById('mobileBuilderGallery');
        const usesCompactGallery = galleryEl && (
            window.matchMedia('(max-width: 63.9375em)').matches ||
            document.body.classList.contains('v3_product_builder_mats_steps')
        );
        if (usesCompactGallery) return;

        // Preload only the current color combo's preview images. The other
        // combos are preloaded on demand in updateSetting() when the user
        // selects them, so a page load no longer fetches every combo.
        await this.preloadImageCombo(`${this.currentSettings.baseColor}-${this.currentSettings.borderColor}`);
    },
    preloadImageCombo: async function (comboKey) {
        const imageSet = this.images[comboKey];
        if (!imageSet) return;
        const imagePromises = [];
        for (const key in imageSet) {
            if (imageSet.hasOwnProperty(key)) {
                if (!imageSet[key] || imageSet[key] === false || imageSet[key] === '#') continue;
                if (this.isVideo(imageSet[key])) continue;
                const imageUrl = this.resizeImage(imageSet[key], '_450x450_crop_center');
                imagePromises.push(this.preloadImage(imageUrl));
            }
        }
        try {
            await Promise.all(imagePromises);
        } catch (error) {
            console.error('Eroare la preîncărcarea imaginilor: ', error);
        }
    },
    preloadImage: function (imageUrl) {
        // Skip URLs that were already requested (e.g. when switching back to a
        // previously preloaded color combo)
        if (this._preloadedImageUrls && this._preloadedImageUrls.has(imageUrl)) {
            return Promise.resolve();
        }
        this._preloadedImageUrls = this._preloadedImageUrls || new Set();
        this._preloadedImageUrls.add(imageUrl);
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => {
                resolve(img);
            };
            img.onerror = () => {
                reject(imageUrl);
            };
        });
    },
    resizeImage: function (filename, string){
        const dotIndex = filename.lastIndexOf(".");
        if (dotIndex === -1) return filename + string;
        return filename.substring(0, dotIndex) + string + filename.substring(dotIndex);
    },
    resizeCdnImage: function (url, width) {
        // Appends a Shopify CDN width param (e.g. .../icon.png?width=200)
        if (!url || url.includes('width=')) return url;
        return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
    },
    gallerySrcset: function (url) {
        // Responsive srcset for the square mobile gallery media — same
        // 480w–1080w candidates + sizes as v2_product_gallery_builder.liquid.
        // Returns '' when the URL already carries a fixed width.
        if (!url || url === '#' || /width=\d+/i.test(url)) return '';
        const out = [];
        [480, 640, 800, 1080].forEach((w) => {
            out.push(this.resizeCdnImage(url, w) + ' ' + w + 'w');
        });
        return out.join(', ');
    },
    setSubmodelVariationDescription: function (key = null) {
        const carSubmodelVariationDescriptionEl = document.getElementById('carSubmodelVariationDescription');
        if (carSubmodelVariationDescriptionEl) {
            if (key === null) {
                carSubmodelVariationDescriptionEl.innerText = '';
            } else {
                carSubmodelVariationDescriptionEl.innerText = PTCProductBuilder.submodelVariationDescriptions[key] ?? '';
            }
        }
    },
    submit: async function (e) {
        e.preventDefault()
        if (PTCProductBuilder._orderBusy) return;
        if (!PTCProductBuilder.validate()) {
            document.getElementById("productBuilderFields").scrollIntoView({ behavior: 'smooth' });
            return;
        }

        PTCProductBuilder._orderBusy = true;
        const submitBtn = document.getElementById('submitProductBuilder');
        submitBtn.disabled = true;
        submitBtn.textContent = PTCProductBuilder.getTranslatedText('btnSending', 'Se trimite...');

        // Fullscreen 3-step loader (texts configurable via config.loadingSteps)
        PTCProductBuilder.loader?.show();

        const formData = new FormData();
        const {price, regularPrice} = PTCProductBuilder.getPriceByCurrentSettings();
        formData.append('location', PTCProductBuilder.location);
        formData.append('title', PTCProductBuilder.getProcessedTitleByCurrentSettings());
        formData.append('price', price);

        try {
            // Step 1: Personalization — build properties (uploads embroidery
            //         images to save-image.php when embroidery is enabled).
            //         When the upsell checkbox is ticked, also prepare the
            //         tunel-cover properties with the same chosen settings.
            PTCProductBuilder.loader?.setStep(0);
            const properties = await PTCProductBuilder.getPropertiesNew();
            PTCProductBuilder.loader?.completeStep(0);

            formData.append('properties', JSON.stringify(properties));

            const upsellActive = PTCProductBuilder.upsellActive();
            const upsellProperties = upsellActive ? PTCProductBuilder.getUpsellProperties() : null;
            let upsellData = null;

            // Step 2: Create the product(s) via their v2 APIs
            PTCProductBuilder.loader?.setStep(1);
            const apiResponse = await fetch(PTCProductBuilder.apiURL, {
                method: 'POST',
                body: formData,
            });
            const data = await apiResponse.json();

            if (!data.success || !data.data?.variantId) {
                console.error('Product creation failed:', data);
                PTCProductBuilder.loader?.hide();
                submitBtn.disabled = false;
                submitBtn.textContent = PTCProductBuilder.getTranslatedText('addToCart', 'Adauga in cos');
                return;
            }

            if (upsellActive) {
                const upsellForm = new FormData();
                upsellForm.append('location', PTCProductBuilder.location);
                upsellForm.append('title', PTCProductBuilder.getUpsellTitle());
                upsellForm.append('price', PTCProductBuilder.upsell.price || '39');
                upsellForm.append('properties', JSON.stringify(upsellProperties));

                const upsellResponse = await fetch(PTCProductBuilder.upsell.endpoint, {
                    method: 'POST',
                    body: upsellForm,
                });
                upsellData = await upsellResponse.json();
                if (!upsellData.success || !upsellData.data?.variantId) {
                    console.error('Upsell product creation failed:', upsellData);
                    PTCProductBuilder.loader?.hide();
                    submitBtn.disabled = false;
                    submitBtn.textContent = PTCProductBuilder.getTranslatedText('addToCart', 'Adauga in cos');
                    return;
                }
            }
            PTCProductBuilder.loader?.completeStep(1);

            // Step 3: Add to Shopify cart (the mats first, then the tunel
            //         cover when the upsell checkbox was ticked)
            PTCProductBuilder.loader?.setStep(2);
            await PTCProductBuilder.addCustomProductToCart(data.data.variantId, properties);
            if (upsellData) {
                await PTCProductBuilder.addCustomProductToCart(upsellData.data.variantId, upsellProperties);
            }
            PTCProductBuilder.loader?.completeStep(2);

            // Step 4: Success
            PTCProductBuilder.storage.removeSettings();
            submitBtn.textContent = PTCProductBuilder.getTranslatedText('addedToCart', 'Adaugat in cos ✓');

            // Show the final checkmark briefly, then refresh the cart UI and
            // open the side cart drawer, the same way the theme does for a
            // regular add-to-cart (theme.js updateCart() + jQuery('.hPCart').show()).
            setTimeout(function () {
                PTCProductBuilder.loader?.hide();
                // Prefer the theme's own cart-refresh global; fall back to the
                // same function exposed as window.bogosUpdateCart by the live
                // theme.js (avoiding any need to edit theme.js itself).
                if (typeof window.updateCart === 'function') {
                    window.updateCart();
                } else if (typeof window.bogosUpdateCart === 'function') {
                    window.bogosUpdateCart();
                }
                if (typeof window.jQuery === 'function') {
                    window.jQuery('.hPCart').show();
                }
            }, 450);

        } catch (error) {
            console.error('Submit error:', error);
            PTCProductBuilder.loader?.hide();
            submitBtn.disabled = false;
            submitBtn.textContent = PTCProductBuilder.getTranslatedText('addToCart', 'Adauga in cos');
        } finally {
            PTCProductBuilder._orderBusy = false;
        }
    },

    /* ── shared cart helpers (used by submit) ────────────────────── */

    buildCartProperties: function (properties) {
        // Complex values (arrays/objects) → JSON string so the cart API
        // accepts them.
        const cartProperties = {};

        for (const [key, value] of Object.entries(properties)) {
            if (key === 'version') continue;

            // Keys that should NOT show up as plain properties in checkout
            if (PTCProductBuilder.invisibleSettingsCheckout.includes(key)) {
                cartProperties['_' + key] = typeof value === 'string'
                    ? value
                    : JSON.stringify(value);
            } else {
                cartProperties[key] = typeof value === 'string'
                    ? value
                    : JSON.stringify(value);
            }
        }

        // Always include odoo_attributes, fixing_system, embroidery as JSON
        if (properties._odoo_attributes) {
            cartProperties['_odoo_attributes'] = JSON.stringify(properties._odoo_attributes);
        }
        if (properties._fixing_system) {
            cartProperties['_fixing_system'] = JSON.stringify(properties._fixing_system);
        }
        if (properties._embroidery) {
            cartProperties['_embroidery'] = JSON.stringify(properties._embroidery);
        }

        return cartProperties;
    },

    addCustomProductToCart: async function (variantId, properties) {
        const cartProperties = PTCProductBuilder.buildCartProperties(properties);
        const cartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: cartProperties,
            }),
        });

        if (!cartResponse.ok) {
            const err = await cartResponse.json();
            console.error('Cart add failed:', err);
            throw new Error('Cart add failed');
        }
        return cartResponse.json();
    },

    /* ── upsell (cross-sell) offer ─────────────────────────────────
       Optional per-product option in the config JSON:
       "upsell": {
         "endpoint": "https://api.ptc-auto.ro/apis/tunel_median_v2.php",
         "text":     "…offer text…",
         "price":    "39",             // optional
         "title":    "Tunel median",   // optional
         "material": "standard",       // optional
         "checked":  false             // optional — pre-tick the checkbox
       }
       Rendered as a checkbox above the add-to-cart button. When the box is
       ticked, the regular submit() also creates the upsell product (via its
       own v2 API endpoint, e.g. the tunnel-cover product) and adds it to the
       cart together with the mats — both carry the same chosen settings
       (base color, edge color, stitching etc.).                             */

    getUpsellCheckbox: function () {
        return document.getElementById('upsellProductCheckbox');
    },

    upsellActive: function () {
        const upsellCfg = this.upsell;
        if (!upsellCfg || !upsellCfg.endpoint) return false;
        const checkbox = this.getUpsellCheckbox();
        return !!(checkbox && checkbox.checked);
    },

    getUpsellTitle: function () {
        const upsellCfg = this.upsell || {};
        const baseTitle = upsellCfg.title || 'Tunel median';
        let brand = '';
        let submodel = '';
        if (this.isActiveCarSetting('carBrand')) {
            brand = this.getSelectedOption('carBrand');
        }
        if (this.isActiveCarSetting('carSubmodel')) {
            submodel = this.getSelectedOption('carSubmodel');
        }
        return `${baseTitle} ${brand} ${submodel}`.replace(/\s+/g, ' ').trim();
    },

    getUpsellProperties: function () {
        const upsellCfg = this.upsell || {};
        const properties = this.getProcessedCurrentSettings(this.currentSettings);

        // The upsell product is a single-item cover with the same car chain
        // and the same colors/stitching as the mats — no mats-only extras.
        ['_carFixingSystem', '_reinforcement', '_configuration', '_embroidery'].forEach((key) => {
            delete properties[key];
        });

        // Same odoo attribute schema as the engine produces, but for the
        // upsell product: its own material, its own title and no
        // reinforcement/embroidery flags inherited from the mats flow.
        const attributes = this.getOdooAttributes().map((attr) => {
            if (attr.name === 'car_mat_material') return {'name': attr.name, 'value': upsellCfg.material || 'standard'};
            if (attr.name === 'submodel_title') return {'name': attr.name, 'value': this.getUpsellTitle()};
            if (attr.name === 'driver_heel_reinforcement' || attr.name === 'embroidery') {
                return {'name': attr.name, 'value': '0'};
            }
            return attr;
        });
        properties['_odoo_attributes'] = attributes;

        return properties;
    },

    getPropertiesNew: async function () {
        const properties = this.getProcessedCurrentSettings(this.currentSettings);
        properties['_odoo_attributes'] = this.getOdooAttributes();
        if (this.isActiveSetting('embroidery') && this.currentSettings.embroidery === 'yes') {
            properties['_embroidery'] = await this.getEmbroideryProperties();
        }
        properties['_fixing_system'] = this.getOdooFixingSystemProperties();
        return properties;
    },
    getOdooAttributes: function () {
        const attributes = [];

        attributes.push({'name': 'car_mat_material', 'value': this.material ?? ''});

        // todo: replace hardcoded value
        attributes.push({'name': 'car_mat_layout', 'value': 'complet'});

        attributes.push({
            'name': 'car_mat_color',
            'value': this.newOdooMappings['car_mat_color']['values'][this.currentSettings.baseColor] ?? this.currentSettings.baseColor
        });

        attributes.push({'name': 'car_mat_edge_material', 'value': this.currentSettings.borderType ?? 'piele'});

        attributes.push({
            'name': 'car_mat_edge_color',
            'value': this.newOdooMappings['car_mat_edge_color']['values'][this.currentSettings.borderColor] ?? this.currentSettings.borderColor
        });

        attributes.push({'name': 'thread_type', 'value': this.currentSettings.threadType ?? ''});

        attributes.push({
            'name': 'thread_color',
            'value': this.newOdooMappings['thread_color']['values'][this.currentSettings.threadColor] ?? this.currentSettings.threadColor
        });

        attributes.push({
            'name': 'submodel_title',
            'value': this.getProcessedTitleByCurrentSettings()
        })

        attributes.push({
            'name': 'driver_heel_reinforcement',
            'value': this.currentSettings.reinforcement === 'yes' ? "1" : "0"
        })

        attributes.push({
            'name': 'embroidery',
            'value': this.currentSettings.embroidery === 'yes' ? "1" : "0"
        })

        return attributes;
    },
    getEmbroideryProperties: async function () {
        const embroideryImages = await this.embroideryBuilder.saveImages();
        const embroideryItemsElements = this.embroideryBuilder.getEmbroideryItemsElements(embroideryImages);
        return Object.values(embroideryItemsElements) ?? [];
    },
    getProperties: async function () {
        const properties = this.getProcessedCurrentSettings(this.currentSettings);
        properties['_odoo_attributes'] = this.getOdooProperties();
        if (this.isActiveSetting('embroidery') && this.currentSettings.embroidery === 'yes') {
            const embroideryImages = await this.embroideryBuilder.saveImages();
            properties['_embroidery'] = embroideryImages;
            properties['_odoo_attributes'].push({
                id: null,
                name: 'Broderie',
                value: this.embroideryBuilder.getEmbroideryItemsElements(embroideryImages)
            });
        }
        return properties;
    },
    getProcessedCurrentSettings: function (currentSettings) {
        return Object.keys(currentSettings).reduce((acc, settingKey) => {
            if (this.isActiveSetting(settingKey) || this.isActiveCarSetting(settingKey)) {
                let value = currentSettings[settingKey];
                if (this.invisibleSettingsCheckout.includes(settingKey)) {
                    settingKey = '_' + settingKey;
                }
                if (this.getOptionLabel.includes(settingKey)) {
                    value = this.getSelectedOption(settingKey) ?? value;
                }
                acc[settingKey] = value;
            }
            return acc;
        }, {});
    },
    getOdooProperties: function () {
        const properties = this.currentSettings;
        const odooMappings = this.odooMappings;
        const odooProperties = [];
        for (const property in properties) {
            const value = properties[property];
            if (property === 'carFixingSystem') {
                odooProperties.push(...this.getOdooFixingSystemProperties());
                continue;
            }
            if (odooMappings.hasOwnProperty(property)) {
                const oddoMapping = odooMappings[property];
                if (oddoMapping.hasOwnProperty('values') && oddoMapping.values.hasOwnProperty(value)) {
                    odooProperties.push({
                        'id': oddoMapping.id,
                        'name': oddoMapping.name,
                        'value': odooMappings[property].values[value]
                    });
                }
            }

        }
        return odooProperties;
    },
    getOdooFixingSystemProperties: function () {
        const currentSubmodel = this.carSettings.carSubmodel;
        const currentFixingSystem = this.carSettings.carFixingSystem;
        const currentBaseColor = this.currentSettings.baseColor;
        const result = [];
        if (this.submodelsFixingSystems.hasOwnProperty(currentSubmodel) && this.submodelsFixingSystems[currentSubmodel].hasOwnProperty(currentFixingSystem)) {
            const fixingSystem = this.submodelsFixingSystems[currentSubmodel][currentFixingSystem];
            result.push({
                'id': 'fixing_system_top',
                'name': 'Sistem de prindere sus',
                'value': fixingSystem[currentBaseColor] ?? ''
            });
            result.push({
                'id': 'fixing_system_bottom',
                'name': 'Sistem de prindere jos',
                'value': fixingSystem.bottom_black ?? ''
            });
            result.push({
                'id': 'fixing_system_type',
                'name': 'Sistem de prindere tip',
                'value': fixingSystem.sistem_de_prindere ?? ''
            });
            result.push({
                'id': 'fixing_system_product_sku',
                'name': 'Sistem de prindere produs SKU',
                'value': fixingSystem.product_sku ?? ''
            });
        }
        return result;
    },
    validate: function () {
        const errorEls = {
            'carBrand': document.getElementById('carBrandError'),
            'carModel': document.getElementById('carModelError'),
            'carSubmodel': document.getElementById('carSubmodelError'),
            'carSubmodelVariation': document.getElementById('carSubmodelVariationError'),
            'carFixingSystem': document.getElementById('carFixingSystemError'),
        }

        let hasError = false;
        for (const key in this.carSettings) {
            if (!this.isActiveCarSetting(key)) continue;
            if (this.carSettings[key] === null) {
                if (!hasError) hasError = true;
                errorEls[key].innerText = this.getTranslatedText('selectAnOption', 'Selecteaza o optiune');
            } else {
                errorEls[key].innerText = '';
            }
        }
        return !hasError;
    },
    isActiveCarSetting: function (settingKey) {
        return Boolean(this.activeCarSettings[settingKey] ?? false);
    },
    isActiveSetting: function (settingKey) {
        return Boolean(this.activeSettings[settingKey] ?? false);
    },
    storage: {
        hasSettings: function () {
            const settings = localStorage.getItem(PTCProductBuilder.storageKey);
            if (settings === null) return false;
            const version = JSON.parse(settings).version ?? false;
            return Boolean(version === PTCProductBuilder.currentSettings.version);
        },
        getSettings: function () {
            const settings = localStorage.getItem(PTCProductBuilder.storageKey);
            return settings ? JSON.parse(settings) : false;
        },
        saveSettings: function (settings) {
            localStorage.setItem(PTCProductBuilder.storageKey, JSON.stringify(settings));
        },
        removeSettings: function () {
            localStorage.removeItem(PTCProductBuilder.storageKey);
        }
    },
    loader: {
        overlay: null,
        stepEls: [],
        currentStep: -1,
        prevOverflow: '',
        defaultSteps: [
            'Se procesează personalizarea...',
            'Se creează produsul tău...',
            'Se adaugă în coș...'
        ],
        getSteps: function () {
            const steps = PTCProductBuilder.loadingSteps ?? [];
            // Fall back to defaults unless the config provides exactly 3 steps
            return steps.length === 3 ? steps : this.defaultSteps;
        },
        ensureStyle: function () {
            if (document.getElementById('ptcBuilderLoaderStyle')) return;
            const style = document.createElement('style');
            style.id = 'ptcBuilderLoaderStyle';
            style.textContent = '' +
                '#ptcBuilderLoader{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.55);font-family:Poppins,Arial,sans-serif}' +
                '#ptcBuilderLoader .ptcLoaderBox{background:#fff;border-radius:16px;padding:28px 32px;width:min(92vw,420px);box-shadow:0 24px 64px rgba(0,0,0,.35)}' +
                '#ptcBuilderLoader .ptcLoaderHead{display:flex;align-items:center;gap:14px;margin-bottom:20px}' +
                '#ptcBuilderLoader .ptcLoaderSpinner{width:30px;height:30px;flex:0 0 auto;border:3px solid #e4e4e4;border-top-color:#002060;border-radius:50%;animation:ptcLoaderSpin .8s linear infinite}' +
                '@keyframes ptcLoaderSpin{to{transform:rotate(360deg)}}' +
                '#ptcBuilderLoader .ptcLoaderHead h3{margin:0;font-size:18px;line-height:1.3;color:#002060}' +
                '#ptcBuilderLoader .ptcLoaderStep{display:flex;align-items:center;gap:12px;padding:10px 0;opacity:.45;transition:opacity .3s ease}' +
                '#ptcBuilderLoader .ptcLoaderStep.active{opacity:1}' +
                '#ptcBuilderLoader .ptcLoaderNr{width:26px;height:26px;flex:0 0 auto;display:flex;align-items:center;justify-content:center;border:2px solid #002060;border-radius:50%;color:#002060;font-size:13px;font-weight:700}' +
                '#ptcBuilderLoader .ptcLoaderStep.done .ptcLoaderNr{background:#1e9e4a;border-color:#1e9e4a;color:#fff;font-size:14px}' +
                '#ptcBuilderLoader .ptcLoaderStepBody{flex:1;min-width:0}' +
                '#ptcBuilderLoader .ptcLoaderStepText{font-size:14px;color:#222;line-height:1.35}' +
                '#ptcBuilderLoader .ptcLoaderBar{height:4px;margin-top:6px;background:#eee;border-radius:4px;overflow:hidden}' +
                '#ptcBuilderLoader .ptcLoaderBarFill{height:100%;width:0;background:#002060;border-radius:4px}' +
                '#ptcBuilderLoader .ptcLoaderStep.active .ptcLoaderBarFill{animation:ptcLoaderFill 1.6s ease-out forwards}' +
                '#ptcBuilderLoader .ptcLoaderStep.done .ptcLoaderBarFill{width:100%!important;background:#1e9e4a;animation:none}' +
                '@keyframes ptcLoaderFill{from{width:0}to{width:100%}}';
            document.head.appendChild(style);
        },
        build: function () {
            const overlay = document.createElement('div');
            overlay.id = 'ptcBuilderLoader';
            overlay.setAttribute('role', 'status');
            overlay.setAttribute('aria-live', 'polite');
            overlay.style.display = 'none';
            const steps = this.getSteps();
            const stepsHtml = steps.map(function (text, i) {
                return '<div class="ptcLoaderStep" data-step="' + i + '">' +
                    '<span class="ptcLoaderNr">' + (i + 1) + '</span>' +
                    '<div class="ptcLoaderStepBody">' +
                    '<div class="ptcLoaderStepText">' + text + '</div>' +
                    '<div class="ptcLoaderBar"><div class="ptcLoaderBarFill"></div></div>' +
                    '</div>' +
                    '</div>';
            }).join('');
            overlay.innerHTML =
                '<div class="ptcLoaderBox">' +
                '<div class="ptcLoaderHead">' +
                '<div class="ptcLoaderSpinner"></div>' +
                '<h3>Te rugăm să aștepți</h3>' +
                '</div>' +
                stepsHtml +
                '</div>';
            document.body.appendChild(overlay);
            this.overlay = overlay;
            this.stepEls = overlay.querySelectorAll('.ptcLoaderStep');
        },
        show: function () {
            this.ensureStyle();
            if (!this.overlay || !document.body.contains(this.overlay)) {
                this.build();
            }
            this.currentStep = -1;
            this.stepEls.forEach(function (el, i) {
                el.classList.remove('active', 'done');
                el.querySelector('.ptcLoaderNr').textContent = String(i + 1);
            });
            this.prevOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            this.overlay.style.display = 'flex';
        },
        setStep: function (index) {
            if (this.currentStep === index) return;
            this.currentStep = index;
            this.stepEls.forEach(function (el, i) {
                el.classList.toggle('active', i === index);
                el.classList.toggle('done', i < index);
            });
        },
        completeStep: function (index) {
            const el = this.stepEls[index];
            if (!el) return;
            el.classList.remove('active');
            el.classList.add('done');
            const nr = el.querySelector('.ptcLoaderNr');
            if (nr) nr.textContent = '✓';
        },
        hide: function () {
            if (!this.overlay) return;
            this.overlay.style.display = 'none';
            document.body.style.overflow = this.prevOverflow;
        }
    },
    getTranslatedText(key, fallback = null) {
        return this.translations[key] ?? fallback;
    },
    embroideryBuilder: {
        itemKeys: [],
        coordinatedAdjustments: {
            'item-1': {
                'text': {
                    'center-bottom': {
                        'x': 20,
                        'y': -55,
                        'rotation': {
                            'no': -8,
                            'yes': -188
                        }
                    },
                    'center-left': {
                        'x': 130,
                        'y': 80,
                        'rotation': {
                            'no': 84,
                            'yes': -98
                        }
                    },
                    'center-right': {
                        'x': 355,
                        'y': 10,
                        'rotation': {
                            'no': 80,
                            'yes': -98
                        }
                    }
                },
                'image': {
                    'center-bottom': {
                        'x': 20,
                        'y': 0,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-left': {
                        'x': -70,
                        'y': 80,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-right': {
                        'x': -80,
                        'y': 30,
                        'offsetX': 0,
                        'offsetY': 0
                    },

                }
            },
            'item-2': {
                'text': {
                    'center-bottom': {
                        'x': 20,
                        'y': -55,
                        'rotation': {
                            'no': -8,
                            'yes': -188
                        }
                    },
                    'center-left': {
                        'x': 130,
                        'y': 80,
                        'rotation': {
                            'no': 84,
                            'yes': -98
                        }
                    },
                    'center-right': {
                        'x': 355,
                        'y': 10,
                        'rotation': {
                            'no': 80,
                            'yes': -98
                        }
                    }
                },
                'image': {
                    'center-bottom': {
                        'x': 20,
                        'y': 0,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-left': {
                        'x': -70,
                        'y': 80,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-right': {
                        'x': -80,
                        'y': 30,
                        'offsetX': 0,
                        'offsetY': 0
                    },

                }
            },
            'item-3': {
                'text': {
                    'center-bottom': {
                        'x': 20,
                        'y': -55,
                        'rotation': {
                            'no': -8,
                            'yes': -188
                        }
                    },
                    'center-left': {
                        'x': 130,
                        'y': 80,
                        'rotation': {
                            'no': 84,
                            'yes': -98
                        }
                    },
                    'center-right': {
                        'x': 355,
                        'y': 10,
                        'rotation': {
                            'no': 80,
                            'yes': -98
                        }
                    }
                },
                'image': {
                    'center-bottom': {
                        'x': 20,
                        'y': 0,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-left': {
                        'x': -70,
                        'y': 80,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-right': {
                        'x': -80,
                        'y': 30,
                        'offsetX': 0,
                        'offsetY': 0
                    },

                }
            },
            'item-4': {
                'text': {
                    'center-bottom': {
                        'x': 20,
                        'y': -55,
                        'rotation': {
                            'no': -8,
                            'yes': -188
                        }
                    },
                    'center-left': {
                        'x': 130,
                        'y': 80,
                        'rotation': {
                            'no': 84,
                            'yes': -98
                        }
                    },
                    'center-right': {
                        'x': 355,
                        'y': 10,
                        'rotation': {
                            'no': 80,
                            'yes': -98
                        }
                    }
                },
                'image': {
                    'center-bottom': {
                        'x': 20,
                        'y': 0,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-left': {
                        'x': -70,
                        'y': 80,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-right': {
                        'x': -80,
                        'y': 30,
                        'offsetX': 0,
                        'offsetY': 0
                    },

                }
            },
            'item-5': {
                'text': {
                    'center-bottom': {
                        'x': 0,
                        'y': -100,
                        'rotation': {
                            'no': 0,
                            'yes': -180
                        }
                    },
                    'center-left': {
                        'x': 120,
                        'y': -50,
                        'rotation': {
                            'no': 90,
                            'yes': -90
                        }
                    },
                    'center-right': {
                        'x': 375,
                        'y': -50,
                        'rotation': {
                            'no': 90,
                            'yes': -90
                        }
                    }
                },
                'image': {
                    'center-bottom': {
                        'x': 20,
                        'y': 0,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-left': {
                        'x': -70,
                        'y': 80,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-right': {
                        'x': -80,
                        'y': 30,
                        'offsetX': 0,
                        'offsetY': 0
                    },

                }
            },
            'item-6': {
                'text': {
                    'center-bottom': {
                        'x': 0,
                        'y': -130,
                        'rotation': {
                            'no': 0,
                            'yes': -180
                        }
                    },
                    'center-left': {
                        'x': 60,
                        'y': 0,
                        'rotation': {
                            'no': 90,
                            'yes': -90
                        }
                    },
                    'center-right': {
                        'x': 440,
                        'y': 0,
                        'rotation': {
                            'no': 90,
                            'yes': -90
                        }
                    }
                },
                'image': {
                    'center-bottom': {
                        'x': 20,
                        'y': 0,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-left': {
                        'x': -70,
                        'y': 80,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-right': {
                        'x': -80,
                        'y': 30,
                        'offsetX': 0,
                        'offsetY': 0
                    },

                }
            },
            'item-7': {
                'text': {
                    'center-bottom': {
                        'x': 0,
                        'y': -100,
                        'rotation': {
                            'no': 0,
                            'yes': -180
                        }
                    },
                    'center-left': {
                        'x': 120,
                        'y': -50,
                        'rotation': {
                            'no': 90,
                            'yes': -90
                        }
                    },
                    'center-right': {
                        'x': 375,
                        'y': -50,
                        'rotation': {
                            'no': 90,
                            'yes': -90
                        }
                    }
                },
                'image': {
                    'center-bottom': {
                        'x': 20,
                        'y': 0,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-left': {
                        'x': -70,
                        'y': 80,
                        'offsetX': 0,
                        'offsetY': 0
                    },
                    'center-right': {
                        'x': -80,
                        'y': 30,
                        'offsetX': 0,
                        'offsetY': 0
                    },

                }
            }
        },
        itemKeyMappings: {
            'item-1': {key: 'covoras_sofer', title: 'Covoras sofer'},
            'item-2': {key: 'covoras_pasager', title: 'Covoras pasager'},
            'item-3': {key: 'covoras_stanga_spate', title: 'Covoras stanga spate'},
            'item-4': {key: 'covoras_dreapta_spate', title: 'Covoras dreapta spate'},
            'item-5': {key: 'tavita_portbagaj', title: 'Tavita portbagaj'},
            'item-6': {key: 'covoras_casa', title: 'Covoras casa'},
            'item-7': {key: 'tunel_median', title: 'Tunel median'}
        },
        svgs: {
            'rug': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2500">
          <defs>
            <style>
              #svgBaseColor, #svgBorderColor {
                fill: #ab9185;
              }
              #svgBaseColor, #svgBorderColor, #svgFirstThreadColor, #svgSecondThreadColor {
                fill-rule: evenodd;
              }
              #svgBorderColor {
                fill-opacity: 0;
                stroke: #f25c86;
                stroke-linejoin: round;
                stroke-width: 45px;
              }
              #svgFirstThreadColor, #svgSecondThreadColor {
                fill: none;
                stroke-width: 3px;
                stroke-dasharray: 12 6;
                stroke: #fff;
              }
            </style>
          </defs>
          <path id="svgBaseColor" d="M820,573c-16.792-91.417-26.458-203.333-23-280s2.792-107.083,125-132,207.17-35.334,296-50,263-43.207,317-50c46.24-5.816,158.17-42.208,176,87s20.42,150.042,21,179,7.92,69.3-44,115c-29.57,26.033-44.61,39.465-54,48-1.81,1.642-6.71,6.854-8.11,8.491C1611.4,515.529,1558.62,630.175,1718,630c39.83-.044,116.42-13.458,154-7,20.52,3.525,63.68,3.507,72,104,8.42,101.708,13.92,159.792,0,236s-32.83,165.29-26,239,28.29,215.62,56,300,40.62,133.62,84,203,97.62,132.29,118,197c16.19,51.43,18.96,164.62,18,218s-2.38,139.62-130,155-327.71,38.29-469,55-415.54,52.96-516,68-248.208,44.29-288,50-165.875,41.46-197-158-60.208-341.54-78-484-45.875-335.71-60-443-21.542-251.71-22-304-0.875-73.042,1-100S420.792,854.292,566,836C768.9,810.442,865.105,818.558,820,573Z"/>
          <path id="svgBorderColor" d="M834.714,587.455c-16.493-89.743-38.809-205.609-35.413-280.872S800.543,195.461,920.576,171s211.8-33.187,299.054-47.584S1480.95,78,1533.98,71.333c45.42-5.709,150.85-41.435,168.37,85.406s18.55,139.794,19.13,168.222,6.57,67.362-44.72,111.893c-55.26,47.977-67.6,72.981-74.76,97.146-12.81,43.231-12.93,109.546,110.22,109.411,39.13-.043,108.35-13.212,145.26-6.872,20.15,3.461,67.05,3.443,75.22,102.1,8.27,99.845,7.67,153.865-6,228.677s-28.78,162.269-22.07,234.619,31.71,211.68,58.93,294.51,34.4,131.18,77,199.28,98,140.37,118.01,203.89c15.91,50.49,33.37,161.61,32.43,214.01s-2.33,132.57-127.68,147.66-334.63,37.59-473.41,53.99-414.14,56.49-512.81,71.26-261.466,43.48-300.55,49.08-153.921,36.2-184.492-159.6-48.957-341.29-66.432-481.14-45.058-329.56-58.931-434.89c-39.78-302-95.331-503.992,99.719-528.549C765.7,806.34,879.015,828.515,834.714,587.455Z"/>
          <path id="svgFirstThreadColor" data-name="Ata 1" d="M830.06,584.662c-16.567-90.119-40.485-207.973-37.073-283.552s3.748-110.589,124.325-135.152,214.258-34.827,301.908-49.284,262.5-45.607,315.78-52.3c45.62-5.733,153.04-39.609,170.63,87.766s21.64,140.381,22.22,168.929,6.6,68.646-44.92,113.364c-55.51,48.178-67.41,71.288-74.6,95.554-12.87,43.413-17.99,108.007,105.72,107.871,39.3-.043,108.84-12.268,145.92-5.9,20.24,3.475,69.35,5.457,77.56,104.524,8.3,100.266,6.7,154.512-7.03,229.639s-27.91,162.944-21.17,235.614,31.86,212.56,59.2,295.74,35.56,131.73,78.35,200.12,96.44,140.96,116.54,204.75c15.98,50.7,33.53,162.29,32.58,214.9s-2.34,131.63-128.26,146.79-337.15,41.74-476.55,58.22-416.02,56.72-515.14,71.55-262.656,41.16-301.917,46.79-156.62,36.35-187.329-160.28-47.179-342.72-64.733-483.15-47.263-330.95-61.2-436.72c-39.96-303.27-93.764-508.115,102.172-532.776C763.23,802.468,874.563,826.737,830.06,584.662Z"/>
          <path id="svgSecondThreadColor" data-name="Ata 2" d="M841.6,591.692c-16.567-90.12-38.985-203.474-35.573-279.052s-7.793-111.59,112.784-136.153S1131.57,143.161,1219.22,128.7,1481.72,83.1,1535,76.4c45.62-5.733,143.5-41.609,161.1,85.765s19.64,137.382,20.21,165.929-4.44,67.646-55.97,112.364c-55.51,48.179-58.86,73.288-66.05,97.554-12.87,43.414-3.95,111.012,119.76,110.875,39.3-.043,108.84-12.267,145.92-5.9,20.24,3.475,59.32,2.457,67.52,101.524,8.31,100.265,4.7,153.508-9.03,228.635s-25.9,162.944-19.16,235.6,32.86,212.57,60.2,295.75,36.56,131.73,79.36,200.12,96.43,140.96,116.53,204.75c15.98,50.7,28.99,160.78,29.07,213.4,0.06,37.56,1.67,114.56-119.22,130.72-125.72,16.8-334.65,38.75-474.05,55.22s-416.02,58.73-515.14,73.56-262.656,41.66-301.917,47.29-143.57,34.34-175.284-145.22c-34.614-195.98-48.183-339.72-65.737-480.16s-44.263-330.94-58.2-436.71c-39.96-303.27-100.778-504.116,95.158-528.776C770.258,813.5,886.1,833.766,841.6,591.692Z"/>
        </svg>`,
            'tray': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2500">
  <defs>
    <style>
      #svgBaseColor, .#svgBorderColor {
        fill: #ab9185;
      }

      #svgBaseColor {
        stroke: #000;
        stroke-width: 1px;
      }

      #svgBaseColor, #svgBorderColor, #svgFirstThreadColor, #svgSecondThreadColor {
        fill-rule: evenodd;
      }

      #svgBorderColor {
        fill-opacity: 0;
        stroke: #f25c86;
        stroke-linejoin: round;
        stroke-width: 45px;
      }

      #svgFirstThreadColor, #svgSecondThreadColor {
        fill: none;
        stroke: #fff;
        stroke-width: 3px;
        stroke-dasharray: 12 6;
      }
    </style>
  </defs>
  <path id="svgBaseColor"  d="M146,1459s29.329-46.08,65-92c25.483-32.81,51.954-54.03,87-70,33.838-15.42,49.285-44.51,53.94-76.09,12.489-84.73,10.112-112.56,40.06-168.91,29.618-55.725,59.557-131.182,72-196s27.475-132.2,12-262c-14.154-118.72-22.062-186.931-25-205-2.975-18.3-8.525-88.7,105-90s291.975-3.7,433-5,479.47-4.2,616,0,352.99,4.124,373,5c16.02,0.7,98.97,17.8,85,106-18.52,116.857-40.53,285.3-37,337s17.82,189.642,34,231,58.32,109.64,61,144,15.83,128.49,29,153c13.13,24.42,41.32,38.52,53,39s36.32,8.52,46,20,72.82,77.52,86,97,22.82,26.52,27,53,33.82,206.02,37,264,7.32,86.02,5,103-5.18,34.02-35,56-33.18,26.02-40,46-16.18,51.52-60,63c-42.13,11.04-32.82,3.75-44,5-13.32,1.48-40.68,11-85,11s-50.18-12-72-12-63.68,26.02-83,32-95.68,11.02-165,18-87.69,2.5-143,31c-55.25,28.47-117.3,70.51-187,87-81.3,19.23-150.69,23.9-221,25-72.2,1.13-147.63-5.32-250-27-79.8-16.9-100.135-26.48-136.226-45.15C801.76,2093.94,768.567,2081.01,713,2077c-56.353-4.07-150.181-11.48-185-15-20.119-2.03-39.681-13.48-65-28s-47.181-11.48-68-7-43.7,5.45-108-7c-85.319-16.52-107.989-14.78-126-71-12.819-40.02-19.181-32.48-34-47s-33.1-16.37-31-75C98.181,1765.98,129.5,1516.5,146,1459Z"/>
  <path id="svgBorderColor" d="M146,1459s29.329-46.08,65-92c25.483-32.81,51.954-54.03,87-70,33.838-15.42,49.285-44.51,53.94-76.09,12.489-84.73,10.112-112.56,40.06-168.91,29.618-55.725,59.557-131.182,72-196s27.475-132.2,12-262c-14.154-118.72-22.062-186.931-25-205-2.975-18.3-8.525-88.7,105-90s291.975-3.7,433-5,479.47-4.2,616,0,352.99,4.124,373,5c16.02,0.7,98.97,17.8,85,106-18.52,116.857-40.53,285.3-37,337s17.82,189.642,34,231,58.32,109.64,61,144,15.83,128.49,29,153c13.13,24.42,41.32,38.52,53,39s36.32,8.52,46,20,72.82,77.52,86,97,22.82,26.52,27,53,33.82,206.02,37,264,7.32,86.02,5,103-5.18,34.02-35,56-33.18,26.02-40,46-16.18,51.52-60,63c-42.13,11.04-32.82,3.75-44,5-13.32,1.48-40.68,11-85,11s-50.18-12-72-12-63.68,26.02-83,32-95.68,11.02-165,18-87.69,2.5-143,31c-55.25,28.47-117.3,70.51-187,87-81.3,19.23-150.69,23.9-221,25-72.2,1.13-147.63-5.32-250-27-79.8-16.9-100.135-26.48-136.226-45.15C801.76,2093.94,768.567,2081.01,713,2077c-56.353-4.07-150.181-11.48-185-15-20.119-2.03-39.681-13.48-65-28s-47.181-11.48-68-7-43.7,5.45-108-7c-85.319-16.52-107.989-14.78-126-71-12.819-40.02-19.181-32.48-34-47s-33.1-16.37-31-75C98.181,1765.98,129.5,1516.5,146,1459Z"/>
  <path id="svgFirstThreadColor" data-name="Ata 1" d="M151.521,1457.95s31.182-45.84,66.675-91.54c25.356-32.64,49.694-51.75,84.565-67.65,33.669-15.34,51.039-46.29,55.671-77.71,12.426-84.3,9.061-112,38.859-168.06,29.47-55.447,58.26-130.527,70.64-195.02s30.338-131.54,14.94-260.69c-14.083-118.126-21.952-186-24.875-203.975-2.96-18.208-15.482-86.758,97.475-88.05s294.515-5.183,434.835-6.475,477.074-4.18,612.924,0,351.22,7.6,371.13,8.475c15.95,0.7,94.98,11.21,81.08,98.97C2037.01,522.5,2017.61,693.1,2021.12,744.54s17.74,188.693,33.83,229.845,59.03,109.1,61.7,143.275,15.74,127.85,28.85,152.24c13.06,24.29,41.11,41.32,52.74,41.8s36.13,8.48,45.77,19.9,72.45,74.13,85.57,93.52,22.7,26.38,26.86,52.73,33.65,204.99,36.82,262.68,7.28,85.59,4.97,102.49-5.15,35.85-34.82,57.72-33.02,23.89-39.8,43.77-16.1,51.26-59.7,62.68c-41.93,10.99-32.66,3.74-43.78,4.98-13.26,1.48-40.48,8.94-84.58,8.94s-49.93-9.94-71.64-9.94-63.36,25.89-82.58,31.84-95.21,10.97-164.18,17.91-87.25,2.49-142.28,30.85c-54.98,28.32-116.72,70.16-186.07,86.56-80.89,19.14-149.94,23.79-219.89,24.88-71.85,1.12-146.89-5.29-248.75-26.87-79.4-16.81-99.638-26.35-135.549-44.92-80.609-41.69-113.635-54.56-168.925-58.56-56.071-4.04-149.43-11.42-184.075-14.92-20.019-2.02-39.483-13.42-64.675-27.86s-46.945-13.43-67.66-8.97-43.484,7.42-107.46-4.96c-84.892-16.43-107.449-14.7-125.37-70.65-12.755-39.81-19.085-32.32-33.83-46.76s-32.93-16.29-30.845-74.63C103.941,1763.4,135.1,1515.17,151.521,1457.95Z"/>
  <path id="svgSecondThreadColor" data-name="Ata 2" d="M138.479,1460.05s29.475-47.31,65.325-93.46c25.61-32.98,56.213-59.3,91.435-75.35,34.007-15.51,49.531-38.74,54.21-70.48,12.55-85.15,8.162-113.12,38.26-169.75,29.766-56,59.854-131.838,72.36-196.98s27.612-132.862,12.06-263.31C457.9,471.407,446.956,402.855,444,384.7c-2.99-18.39-5.568-89.145,108.525-90.45s293.434-3.72,435.165-5.025,481.876-4.222,619.076,0,352.76,6.145,372.87,7.025c16.1,0.7,101.47,15.888,87.42,104.53-18.6,117.442-38.72,286.725-35.18,338.685s16.91,190.59,33.17,232.155,59.61,110.195,62.3,144.725,15.91,128.13,29.15,152.76c13.19,24.54,39.52,34.71,51.26,35.2s36.5,11.55,46.23,23.1,73.19,76.9,86.43,96.48,22.94,25.65,27.14,52.27,33.99,211.04,37.18,269.32,7.36,86.44,5.03,103.51-5.21,34.19-35.18,56.28-34.34,26.15-41.2,46.23-15.26,51.77-59.3,63.32c-42.34,11.09-32.98,5.77-44.22,7.02-13.38,1.49-40.88,11.06-85.42,11.06s-56.43-10.06-78.36-10.06-58,22.14-77.42,28.16-96.16,11.07-165.82,18.09-88.13,2.51-143.72,31.15c-55.52,28.61-117.88,70.87-187.93,87.44-81.71,19.32-151.44,24.02-222.11,25.12-72.56,1.13-148.36-5.34-251.25-27.13-80.2-16.99-100.632-26.62-136.9-45.38-81.419-42.12-114.777-55.11-170.622-59.14-56.635-4.1-150.932-11.55-185.925-15.08-20.22-2.04-39.88-13.55-65.325-28.14s-47.417-9.54-68.34-5.03-43.922,3.47-108.54-9.04c-85.746-16.6-108.529-14.85-126.63-71.35-12.883-40.22-19.277-32.65-34.17-47.24s-33.261-16.45-31.155-75.37C92.421,1768.56,121.9,1517.83,138.479,1460.05Z"/>
</svg>`,
            'house': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2500">
  <defs>
    <style>
      .cls-1, .cls-2 {
        fill: #ab9185;
      }

      .cls-2 {
        fill-opacity: 0;
        stroke: #f25c86;
        stroke-linejoin: round;
        stroke-width: 45px;
      }

      .cls-3 {
        fill: none;
        stroke: #fff;
        stroke-width: 3px;
        stroke-dasharray: 12 6;
        fill-rule: evenodd;
      }
    </style>
  </defs>
  <rect id="svgBaseColor" class="cls-1" x="150" y="500" width="2200" height="1500" rx="150" ry="150"/>
  <rect id="svgBorderColor" class="cls-2" x="150" y="500" width="2200" height="1500" rx="150" ry="150"/>
  <path id="svgFirstThreadColor" data-name="Ata 1" class="cls-3" d="M295,495H2205a150,150,0,0,1,150,150V1855a150,150,0,0,1-150,150H295a150,150,0,0,1-150-150V645A150,150,0,0,1,295,495Z"/>
  <path id="svgSecondThreadColor" data-name="Ata 2" class="cls-3" d="M305,505H2195a150,150,0,0,1,150,150V1845a150,150,0,0,1-150,150H305a150,150,0,0,1-150-150V655A150,150,0,0,1,305,505Z"/>
</svg>`
        },
        svgsByItemKey: {},
        canvas: {
            'item-1': {
                'page': {
                    'containerId': 'embroideryImageItem1'
                },
                'modal': {
                    'containerId': 'embroideryModalImageItem1'
                }
            },
            'item-2': {
                'page': {
                    'containerId': 'embroideryImageItem2'
                },
                'modal': {
                    'containerId': 'embroideryModalImageItem2'
                }
            },
            'item-3': {
                'page': {
                    'containerId': 'embroideryImageItem3'
                },
                'modal': {
                    'containerId': 'embroideryModalImageItem3'
                }
            },
            'item-4': {
                'page': {
                    'containerId': 'embroideryImageItem4'
                },
                'modal': {
                    'containerId': 'embroideryModalImageItem4'
                }
            },
            'item-5': {
                'page': {
                    'containerId': 'embroideryImageItem5'
                },
                'modal': {
                    'containerId': 'embroideryModalImageItem5'
                }
            },
            'item-6': {
                'page': {
                    'containerId': 'embroideryImageItem6'
                },
                'modal': {
                    'containerId': 'embroideryModalImageItem6'
                }
            },
            'item-7': {
                'page': {
                    'containerId': 'embroideryImageItem7'
                },
                'modal': {
                    'containerId': 'embroideryModalImageItem7'
                }
            }
        },
        init: function () {
            this.itemKeys = PTCProductBuilder.embroideryItemKeys;
            this.initSvgByItemKey();
            this.loadStages();
            this.updateCanvasByCurrentSettings();
            this.addListeners();
            this.initModals();
            this.initEmbroideryIconGrid();
        },
        initEmbroideryIconGrid: function () {
            // Defer the icon thumbnails until the embroidery modal actually
            // opens, and serve them at thumbnail size instead of full-res.
            document.querySelectorAll('#embroideryIcon .option-value.image img').forEach(img => {
                img.loading = 'lazy';
                img.src = PTCProductBuilder.resizeCdnImage(img.src, 200);
            });
        },
        addListeners: function () {
            const embroideryEditAllModalBtn = document.getElementById('embroideryEditAllModalBtn');
            if (embroideryEditAllModalBtn) {
                embroideryEditAllModalBtn.addEventListener('click', function () {
                    PTCProductBuilder.embroideryBuilder.showEmbroideryEditModal('all');
                });
            }
            const embroideryEditCustomModalBtn = document.getElementById('embroideryEditCustomModalBtn');
            if (embroideryEditCustomModalBtn) {
                document.getElementById('embroideryEditCustomModalBtn').addEventListener('click', function () {
                    PTCProductBuilder.embroideryBuilder.showEmbroideryEditModal('custom');
                });
            }
            document.getElementById('embroideryElementType').querySelectorAll('.option-value.box input[type="radio"]').forEach(checkbox => {
                checkbox.addEventListener('change', PTCProductBuilder.embroideryBuilder.changeElementType)
            });
            document.getElementById('embroideryItem').querySelectorAll('.option-value.box input[type="radio"]').forEach(checkbox => {
                checkbox.addEventListener('change', PTCProductBuilder.embroideryBuilder.changeItem)
            });

            document.getElementById('embroideryTextForm').addEventListener('submit', this.addElementByForm);
            document.getElementById('embroideryIconForm').addEventListener('submit', this.addElementByForm);

            document.getElementById('embroideryTextInput').addEventListener('input', this.updateAfterInputTextForm);
            document.getElementById('embroideryRotateIcon').addEventListener('input', this.rotateSelectedIcon);
            document.getElementById('embroideryIcon').querySelectorAll('.option-value.image input[type="radio"]').forEach(checkbox => {
                checkbox.addEventListener('change', PTCProductBuilder.embroideryBuilder.changeIcon)
            });

            document.getElementById('removeText').addEventListener('click', this.removeText.bind(this));
            document.getElementById('removeIcon').addEventListener('click', this.removeIcon.bind(this));

            document.getElementById('embroideryTextFlip').querySelectorAll('.option-value.box input[type="radio"]').forEach(checkbox => {
                checkbox.addEventListener('change', PTCProductBuilder.embroideryBuilder.flipText);
            });
            document.getElementById('embroideryTextPosition').querySelectorAll('.option-value.box input[type="radio"]').forEach(checkbox => {
                checkbox.addEventListener('change', PTCProductBuilder.embroideryBuilder.changeTextPosition)
            });
            document.getElementById('embroideryTextFont').querySelectorAll('.option-value.box input[type="radio"]').forEach(checkbox => {
                checkbox.addEventListener('change', PTCProductBuilder.embroideryBuilder.changeFont)
            });
        },
        initSvgByItemKey: function () {
            this.svgsByItemKey = {
                'item-1': this.svgs.rug,
                'item-2': this.svgs.rug,
                'item-3': this.svgs.rug,
                'item-4': this.svgs.rug,
                'item-5': this.svgs.tray,
                'item-6': this.svgs.house,
                'item-7': this.svgs.tray
            }
        },
        loadStages: function () {
            for (const itemKey of this.itemKeys) {
                for (const location in this.canvas[itemKey]) {
                    this.loadStage(itemKey, location);
                }
            }
        },
        loadStage: function (itemKey, location) {
            const containerId = this.canvas[itemKey][location].containerId;
            this.canvas[itemKey][location].stage = new Konva.Stage({
                container: containerId ,
                width: 500,
                height: 500
            });
            this.canvas[itemKey][location].layer = new Konva.Layer();
            this.canvas[itemKey][location].stage.add(this.canvas[itemKey][location].layer);
        },
        updateCanvasByCurrentSettings: function () {
            const currentSettings = PTCProductBuilder.currentSettings;
            const colorHexMappings = PTCProductBuilder.colorHexMappings;
            const secondThreadKey = currentSettings.threadType === 'simple' ? 'borderColor' : 'threadColor';
            const settings = {
                baseColor: colorHexMappings[currentSettings.baseColor],
                borderColor: colorHexMappings[currentSettings.borderColor],
                firstThreadColor: colorHexMappings[currentSettings.threadColor],
                secondThreadColor: colorHexMappings[currentSettings[secondThreadKey]],
            };
            for (const itemKey of this.itemKeys) {
                for (const location in this.canvas[itemKey]) {
                    this.updateItemCanvasBySettings(itemKey, location, settings);
                }
            }
        },
        updateItemCanvasBySettings: function (itemKey, location, settings) {
            const svgStrings = this.getSVGBySettings(itemKey, settings);

            const svgBlob = new Blob([svgStrings], {type: 'image/svg+xml'});
            const url = URL.createObjectURL(svgBlob);

            const img = new Image();
            img.onload = function () {
                const background = new Konva.Image({
                    image: img,
                    x: 0,
                    y: 0,
                    width: 500,
                    height: 500
                });
                const layer = PTCProductBuilder.embroideryBuilder.canvas[itemKey][location].layer;
                layer.destroyChildren();
                layer.add(background);
                layer.draw();
                const itemActions = PTCProductBuilder.embroideryBuilder.settings.getItemActions(itemKey, location);
                PTCProductBuilder.embroideryBuilder.applyElementsToItemCanvasByItemActions(itemKey, location, itemActions);
                URL.revokeObjectURL(url);

            };
            img.src = url;
        },
        applyElementsToItemCanvasByItemActions: function (itemKey, location, itemActions) {
            for (const itemActionKey in itemActions) {
                const actionDetails = itemActions[itemActionKey];
                switch (actionDetails.type) {
                    case 'text':
                        this.saveText(itemKey, location, actionDetails, true);
                        break;
                    case 'icon':
                        this.saveIcon(itemKey, location, actionDetails, true);
                }
            }
        },
        getSVGBySettings: function (itemKey, settings) {
            const svg = this.svgsByItemKey[itemKey];
            const svgDocument = new DOMParser().parseFromString(svg, 'image/svg+xml');

            const svgBaseColorEl = svgDocument.getElementById('svgBaseColor');
            if (svgBaseColorEl) {
                svgBaseColorEl.style.fill = settings.baseColor;
            }

            const svgBorderColorEl = svgDocument.getElementById('svgBorderColor');
            if (svgBorderColorEl) {
                svgBorderColorEl.style.stroke = settings.borderColor;
            }

            const svgFirstThreadColorEl = svgDocument.getElementById('svgFirstThreadColor');
            if (svgFirstThreadColorEl) {
                svgFirstThreadColorEl.style.stroke = settings.firstThreadColor;
            }

            const svgSecondThreadColorEl = svgDocument.getElementById('svgSecondThreadColor');
            if (svgSecondThreadColorEl) {
                svgSecondThreadColorEl.style.stroke = settings.secondThreadColor;
            }

            return new XMLSerializer().serializeToString(svgDocument);
        },
        initModals: function () {
            this.editEmbroideryModal = new tingle.modal({
                contentId: 'embroideryEditModal',
                onClose: PTCProductBuilder.updatePrice.bind(PTCProductBuilder)
            });
        },
        showEmbroideryEditModal: function (type, specificItemKey = null) {
            PTCProductBuilder.embroideryBuilder.beforeOpenEmbroideryEditModal(type, specificItemKey);
            PTCProductBuilder.embroideryBuilder.editEmbroideryModal.open();
            PTCProductBuilder.embroideryBuilder.afterOpenEmbroideryEditModal(type, specificItemKey);
        },
        beforeOpenEmbroideryEditModal: function (type, specificItemKey) {
            if (type !== 'all' || specificItemKey) type = specificItemKey ?? this.itemKeys[0];
            document.getElementById('textItem').value = type;
            document.getElementById('iconItem').value = type;
            document.getElementById('embroideryItem').style.display = (type === 'all') ? 'none' : 'block';
            this.applyItemSettings(specificItemKey ?? this.itemKeys[0]);
            this.displayModalCanvasByItem(specificItemKey ?? this.itemKeys[0]);
            this.updateEmbroideryEditModal(type);
        },
        afterOpenEmbroideryEditModal: function (type, specificItemKey) {
            this.updateFontTextByPositionAndFlipByCurrentOptions();
        },
        changeElementType: function () {
            const displayText = this.value === 'text' ? 'block' : 'none';
            const displayImage = this.value === 'image' ? 'block' : 'none';
            document.getElementById('embroideryTextForm').style.display = displayText;
            document.getElementById('embroideryIconForm').style.display = displayImage;
        },
        getItemKeysByFormParams: function (formParams) {
            return formParams.item === 'all' ? this.itemKeys : [formParams.item];
        },
        addElementByForm: function (e) {
            e.preventDefault();

            const formId = e.target.id;
            if (!Boolean(['embroideryTextForm', 'embroideryIconForm'].includes(formId))) return;
            const formData = new FormData(this);
            const params = {};
            formData.forEach((value, key) => params[key] = value);

            const itemKeys = PTCProductBuilder.embroideryBuilder.getItemKeysByFormParams(params);
            for (const itemKey of itemKeys) {
                if (formId === 'embroideryTextForm') {
                    const itemCanvas = PTCProductBuilder.embroideryBuilder.canvas[itemKey];
                    for (const location in itemCanvas) {
                        PTCProductBuilder.embroideryBuilder.saveText(itemKey, location, params);
                    }
                }
                if (formId === 'embroideryIconForm') {
                    const itemCanvas = PTCProductBuilder.embroideryBuilder.canvas[itemKey];
                    for (const location in itemCanvas) {
                        PTCProductBuilder.embroideryBuilder.saveIcon(itemKey, location, params);
                    }
                }
            }
            PTCProductBuilder.embroideryBuilder.applyItemSettings(itemKeys[0]);
            if (document.activeElement.dataset.type === 'save-close') {
                PTCProductBuilder.embroideryBuilder.editEmbroideryModal.close();
            }
        },
        saveText: function (itemKey, location, params, reload = false) {
            let element = this.settings.getItemActionElement(itemKey, location, 'text');

            let beforePosition = element ? this.settings.getItemActionPosition(itemKey, location, 'text') : false;

            const action = {
                type: 'text',
                content: params.content,
                position: params.position,
                font: params.font,
                color: params.color,
                flip: params.flip
            };

            const stage = this.canvas[itemKey][location].stage;
            const layer = this.canvas[itemKey][location].layer;

            const coordinatedAdjustments = this.coordinatedAdjustments[itemKey]['text'];
            const positions = {
                'center-bottom': {
                    x: stage.width() / 2 + coordinatedAdjustments['center-bottom'].x,
                    y: stage.height() + coordinatedAdjustments['center-bottom'].y,
                    rotation: coordinatedAdjustments['center-bottom']['rotation'][params.flip],
                },
                'center-left': {
                    x: coordinatedAdjustments['center-left'].x,
                    y: stage.height() / 2 + coordinatedAdjustments['center-left'].y,
                    rotation: coordinatedAdjustments['center-left']['rotation'][params.flip],
                },
                'center-right': {
                    x: coordinatedAdjustments['center-right'].x,
                    y: stage.height() / 2 + coordinatedAdjustments['center-right'].y,
                    rotation: coordinatedAdjustments['center-right']['rotation'][params.flip],
                }
            };

            if (element && !reload) {
                const position = positions[params.position];
                element.text(params.content);
                element.fontFamily(params.font);
                element.fill(params.color);
                element.position({
                    x: position.x,
                    y: position.y,
                });
                element.rotation(position.rotation);

                switch (params.position) {
                    case 'center-bottom':
                        element.offsetY(element.height() / 2);
                        element.offsetX(element.width() / 2);
                        break;
                    case 'center-left':
                    case 'center-right':
                        element.offsetX(element.width() / 2);
                        element.offsetY(element.height() / 2);
                        break;
                }
                this.settings.replaceItemPosition(itemKey, 'text', beforePosition, params.position);
            } else {
                element = new Konva.Text({
                    text: params.content,
                    fontSize: params.size ? params.size : 30,
                    fontFamily: params.font ? params.font : 'Arial',
                    fill: params.color ? params.color : 'black',
                    offsetX: 0,
                    offsetY: 0,
                    align: 'center',
                    ...positions[params.position] ?? {}
                });

                switch (params.position) {
                    case 'center-bottom':
                        element.offsetY(element.height() / 2);
                        element.offsetX(element.width() / 2);
                        break;
                    case 'center-left':
                    case 'center-right':
                        element.offsetX(element.width() / 2);
                        element.offsetY(element.height() / 2);
                        break;
                }
                this.settings.setItemPosition(itemKey, 'text', params.position);
                layer.add(element);
            }

            action.element = element;
            this.settings.setItemAction(action, itemKey, location);
            document.getElementById('removeText').style.display = 'block';
            layer.draw();

            return element ? 'update' : 'new';
        },
        saveIcon: function (itemKey, location, params, reload = false) {
            let element = this.settings.getItemActionElement(itemKey, location, 'icon');

            let beforePosition = element ? this.settings.getItemActionPosition(itemKey, location, 'icon') : false;

            const action = {
                type: 'icon',
                icon: params.icon,
                position: params.position,
                rotate: params.rotate
            }
            this.settings.setItemAction(action, itemKey, location);

            const stage = this.canvas[itemKey][location].stage;
            const layer = this.canvas[itemKey][location].layer;

            const imageObj = new Image();
            imageObj.crossOrigin = 'Anonymous';
            // Resized copy is plenty for the 150x150 canvas slot
            imageObj.src = PTCProductBuilder.resizeCdnImage(
                PTCProductBuilder.embroideryIconsURL + params.icon + '.png',
                300
            );

            const imgSize = {
                width: 150,
                height: 150
            };

            const coordinatedAdjustments = this.coordinatedAdjustments[itemKey]['image'];

            const positions = {
                'center-bottom': {
                    x: (stage.width() - imgSize.width) / 2 + coordinatedAdjustments['center-bottom'].x,
                    y: stage.height() - imgSize.height + coordinatedAdjustments['center-bottom'].y,
                    offsetX: imgSize.width / 2 + coordinatedAdjustments['center-bottom'].offsetX,
                    offsetY: imgSize.height / 2 + coordinatedAdjustments['center-bottom'].offsetY
                },
                'center-left': {
                    x: imgSize.height + coordinatedAdjustments['center-left'].x,
                    y: (stage.height() - imgSize.width) / 2 + coordinatedAdjustments['center-left'].y,
                    offsetX: imgSize.width / 2 + coordinatedAdjustments['center-left'].offsetX,
                    offsetY: imgSize.height / 2 + coordinatedAdjustments['center-left'].offsetY
                },
                'center-right': {
                    x: (stage.width() - imgSize.width) + coordinatedAdjustments['center-right'].x,
                    y: (stage.height() - imgSize.width) / 2 + coordinatedAdjustments['center-right'].y,
                    offsetX: imgSize.width / 2 + coordinatedAdjustments['center-right'].offsetX,
                    offsetY: imgSize.height / 2 + coordinatedAdjustments['center-right'].offsetY
                }
            };

            if (element && !reload) {
                element.image(imageObj);
                const position = positions[params.position];
                element.position({
                    x: position.x,
                    y: position.y,
                });

                element.rotation(params.rotate - 8);

                element.x(element.x() + element.offsetX());
                element.y(element.y() + element.offsetY());

                this.settings.replaceItemPosition(itemKey, 'icon', beforePosition, params.position);
            } else {
                element = new Konva.Image({
                    image: imageObj,
                    width: imgSize.width,
                    height: imgSize.height,
                    ...positions[params.position] ?? {}
                });

                element.rotation(params.rotate - 8);

                element.x(element.x() + element.offsetX());
                element.y(element.y() + element.offsetY());

                layer.add(element);

                this.settings.setItemPosition(itemKey, 'icon', params.position);

            }
            action.element = element;
            this.settings.setItemAction(action, itemKey, location);
            document.getElementById('removeIcon').style.display = 'block';
            layer.draw();

            return element ? 'update' : 'new';
        },
        removeText: function () {
            const itemKey = document.getElementById('textItem').value;
            this.removeElementsFromItems(itemKey, 'text');
            document.getElementById('removeText').style.display = 'none';
        },
        removeIcon: function () {
            const itemKey = document.getElementById('iconItem').value;
            this.removeElementsFromItems(itemKey, 'icon');
            document.getElementById('removeIcon').style.display = 'none';
        },
        removeElementsFromItems: function (item, type) {
            const itemKeys = item === 'all' ? this.itemKeys : [item];
            for (const itemKey of itemKeys) {
                const itemActions = this.settings.getItemActions(itemKey)
                for (const location in itemActions) {
                    this.removeElementsFromItem(itemKey, location, type);
                }
            }
            this.applyItemSettings(itemKeys[0]);
        },
        removeElementsFromItem: function (itemKey, location, type) {
            const itemAction = this.settings.getItemAction(itemKey, location, type);
            const element = itemAction.element;
            this.settings.unsetItemAction(itemKey, location, type);
            this.settings.unsetItemPosition(itemKey, itemAction.position);
            element.destroy();
            this.canvas[itemKey][location].layer.draw();
            this.resetForms(itemKey);
        },
        resetForms: function (formType = null) {
            if (formType) {
                const formKey = formType === 'text' ? 'embroideryTextForm' : 'embroideryIconForm'
                document.getElementById(formKey).reset();
            } else {
                document.getElementById('embroideryTextForm').reset();
                document.getElementById('embroideryIconForm').reset();
            }
        },
        changeItem: function () {
            const itemKey = this.value
            document.getElementById('textItem').value = itemKey;
            document.getElementById('iconItem').value = itemKey;
            PTCProductBuilder.embroideryBuilder.applyItemSettings(itemKey);
            PTCProductBuilder.embroideryBuilder.displayModalCanvasByItem(itemKey);
            PTCProductBuilder.embroideryBuilder.updateEmbroideryEditModal();
        },
        applyItemSettings: function (itemKey) {
            this.selectOption('embroideryItem', itemKey);
            this.resetForms();
            const settings = this.settings.getItemActions(itemKey);
            let hasText = false;
            let hasIcon = false;
            if (settings) {
                for (const location in settings) {
                    for (const itemType in settings[location]) {
                        this.applyItemSettingsToForm(itemKey, location, itemType);
                        if (itemType === 'text') hasText = true;
                        if (itemType === 'icon') hasIcon = true;
                    }
                }
            }
            this.updateRemoveBtns(hasText, hasIcon);
            this.updateAvailablePositions(itemKey === 'all' ? 'item-1' : itemKey);
            const textValue = document.getElementById('embroideryTextInput').value;
            this.updateFontOptionsByText(textValue);
            this.updateFontTextByPositionAndFlipByCurrentOptions();
            PTCProductBuilder.updatePrice();
        },
        applyItemSettingsToForm: function (itemKey, location, type) {
            const options = PTCProductBuilder.embroiderySettings.itemActions[itemKey][location][type];
            const element = this.settings.getItemActionElement(itemKey, location, type);

            if (type === 'text') {
                document.getElementById('embroideryTextInput').value = options.content;
                this.updateFontOptionsByText(options.content);
                this.selectOption('embroideryTextFont', options.font);
                this.selectOption('embroideryTextPosition', options.position);
                this.selectOption('embroideryTextColor', options.color);
                this.selectOption('embroideryTextFlip', options.flip);
            }

            if (type === 'icon') {
                this.selectOption('embroideryIcon', options.icon);
                this.selectOption('embroideryIconPosition', options.position);
                document.getElementById('embroideryRotateIcon').value = options.rotate;
                document.getElementById('removeIcon').style.display = element ? 'block' : 'none';
            }
        },
        updateEmbroideryEditModal: function (type) {
            const titleEl = document.getElementById('embroideryEditModalTitle');
            if (type === 'all') {
                titleEl.textContent = PTCProductBuilder.getTranslatedText('allMats', 'Toate covorasele');
            } else {
                titleEl.textContent = PTCProductBuilder.getCheckedRadioOptionText('embroideryItem');
            }
        },
        updateRemoveBtns: function (hasText = undefined, hasIcon = undefined) {
            const removeText = document.getElementById('removeText');
            const removeIcon = document.getElementById('removeIcon');

            if (removeText && hasText !== undefined) {
                removeText.style.display = hasText ? 'block' : 'none';
            }
            if (removeIcon && hasIcon !== undefined) {
                removeIcon.style.display = hasIcon ? 'block' : 'none';
            }
        },
        updateAfterInputTextForm: function (e) {
            const currentText = e.target.value;
            PTCProductBuilder.embroideryBuilder.updateFontOptionsByText(currentText);
        },
        updateFontOptionsByText: function (text) {
            const fontOptions = document.getElementById('embroideryTextFont');
            const fontOption = fontOptions.querySelectorAll('.box-text');
            fontOption.forEach(fontOption => {
                fontOption.textContent = text;
            });
            const position = PTCProductBuilder.getCheckedRadioValue('embroideryTextPosition');
            const flip = PTCProductBuilder.getCheckedRadioValue('embroideryTextFlip');
            PTCProductBuilder.embroideryBuilder.updateFontTextByPositionAndFlip(position, flip);
        },
        updateFontTextByPositionAndFlipByCurrentOptions: function () {
            const position = PTCProductBuilder.getCheckedRadioValue('embroideryTextPosition');
            const flip = PTCProductBuilder.getCheckedRadioValue('embroideryTextFlip');
            PTCProductBuilder.embroideryBuilder.updateFontTextByPositionAndFlip(position, flip);
        },
        flipText: function () {
            const position = PTCProductBuilder.getCheckedRadioValue('embroideryTextPosition');
            PTCProductBuilder.embroideryBuilder.updateFontTextByPositionAndFlip(position, this.value);
        },
        changeTextPosition: function () {
            const flip = PTCProductBuilder.getCheckedRadioValue('embroideryTextFlip');
            PTCProductBuilder.embroideryBuilder.updateFontTextByPositionAndFlip(this.value, flip);
        },
        changeFont: function () {
            document.getElementById('embroideryTextFont').querySelectorAll('.option-value.box input[type="radio"]').forEach(checkbox => {
                const parent = checkbox.closest('.option-value.box');
                if (checkbox.checked) {
                    parent.classList.add('checked');
                } else {
                    parent.classList.remove('checked');
                }
            });
        },
        updateFontTextByPositionAndFlip(position, flip) {
            let rotateValue;
            let isDefaultHeight = true;

            if (position === 'center-left' || position === 'center-right' ) {
                isDefaultHeight = false;
                rotateValue = flip === 'yes' ? -90 : 90;
            } else {
                rotateValue = flip === 'yes' ? 180 : 0;
            }

            const fontOptions = document.getElementById('embroideryTextFont');
            fontOptions.querySelectorAll('.box-text').forEach(fontOption => {
                fontOption.style.transform = `rotate(${rotateValue}deg)`;
                const parent = fontOption.closest('.option-value.box');
                if (isDefaultHeight) {
                    parent.style.height = 'auto';
                    parent.style.width = 'auto';
                } else {
                    parent.style.height = (fontOption.offsetWidth ?? 0) + 'px';
                    parent.style.width = (fontOption.offsetHeight + 20 ?? 0) + 'px';
                }
            });
        },
        changeIcon: function () {
            document.getElementById('embroideryIcon').querySelectorAll('.option-value.image input[type="radio"]').forEach(checkbox => {
                const parent = checkbox.closest('.option-value.image');
                if (checkbox.checked) {
                    parent.classList.add('checked');
                } else {
                    parent.classList.remove('checked');
                }
                parent.querySelector('img').style.transform = 'none';

            });
            document.getElementById('embroideryRotateIcon').value = 0;
        },
        updateAvailablePositions: function (itemKey) {
            const currentPositionsByType = {};
            const currentPositions = this.settings.getItemCurrentPositions(itemKey);
            if (currentPositions) {
                for (const currentPosition in currentPositions) {
                    const type = currentPositions[currentPosition];
                    currentPositionsByType[type] = currentPosition;
                }
            }
            for (const type of ['text', 'icon']) {
                const currentPosition = currentPositionsByType[type] ?? false;
                if (type === 'text') {
                    const embroideryIconPosition = document.getElementById('embroideryIconPosition');
                    const options = embroideryIconPosition.querySelectorAll('input');
                    const checkedPosition = PTCProductBuilder.getCheckedRadioValue('embroideryIconPosition');
                    let hasCheckedOption = !!(checkedPosition && checkedPosition !== currentPosition);
                    options.forEach(option => {
                        option.disabled = option.value === currentPosition;
                        if (option.disabled && !hasCheckedOption) {
                            option.checked = false;
                            hasCheckedOption = false;
                        }
                        if (!hasCheckedOption && option.value !== currentPosition) {
                            option.checked = true;
                            hasCheckedOption = true;
                        }
                    });
                }
                if (type === 'icon') {
                    const embroideryTextPosition = document.getElementById('embroideryTextPosition');
                    const options = embroideryTextPosition.querySelectorAll('input');
                    const checkedPosition = PTCProductBuilder.getCheckedRadioValue('embroideryTextPosition');
                    let hasCheckedOption = !!(checkedPosition && checkedPosition !== currentPosition);
                    options.forEach(option => {
                        option.disabled = option.value === currentPosition;
                        if (option.disabled && !hasCheckedOption) {
                            option.checked = false;
                            hasCheckedOption = false;
                        }
                        if (!hasCheckedOption && option.value !== currentPosition) {
                            option.checked = true;
                            hasCheckedOption = true;
                        }
                    });
                }
            }
        },
        rotateSelectedIcon: function () {
            const rotateValue = this.value;
            const embroideryIcons = document.getElementById('embroideryIcon');
            const icons = embroideryIcons.querySelectorAll('input');
            icons.forEach(icon => {
                if(icon.checked) {
                    icon.parentNode.querySelector('img').style.transform = `rotate(${rotateValue}deg)`;
                }
            });
        },
        displayModalCanvasByItem: function (itemKey) {
            for (const key of this.itemKeys) {
                const elementId = this.canvas[key].modal.containerId;
                document.getElementById(elementId).style.display = itemKey === key ? 'block' : 'none';
            }
        },
        selectOption: function (optionID, value) {
            const optionsContainer = document.getElementById(optionID);
            const radioButtons = optionsContainer.querySelectorAll('input');
            radioButtons.forEach(radioButton => {
                radioButton.checked = radioButton.value === value;
            });
        },
        saveImages: async function () {
            const images = {}
            for (const itemKey of this.itemKeys) {
                images[itemKey] = await this.saveImage(itemKey);
            }
            return images;
        },
        saveImage: async function (itemKey) {
            let imageUrl = '';
            const stage = this.canvas[itemKey].page.stage;
            const dataURL = stage.toDataURL();
            try {
                const response = await fetch(PTCProductBuilder.embroiderySaveImageURL, {
                    method: 'POST',
                    body: JSON.stringify({ image: dataURL }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.status) {
                    console.error('Error saving image');
                }

                const data = await response.json();
                imageUrl = PTCProductBuilder.embroideryImagesURL  + data.url;
            } catch (error) {
                console.error('Error saving image:', error);
            }
            return imageUrl;
        },
        getEmbroideryItemsElements: function (images = {}) {
            const itemsElements = {};
            const itemActions = PTCProductBuilder.embroiderySettings.itemActions;
            if (Object.keys(itemActions).length === 0) return itemsElements;
            for (const itemKey in itemActions) {
                const mapping = this.itemKeyMappings[itemKey] ?? false;
                const mappedItemKey = mapping.key ?? itemKey;
                if (itemActions[itemKey].hasOwnProperty('page')) {
                    itemsElements[mappedItemKey] = {
                        title: mapping.title ?? '',
                        image: images[itemKey] ?? ''
                    };
                    const elements = itemActions[itemKey].page;
                    for (const elementKey in elements) {
                        itemsElements[mappedItemKey][elementKey] = elements[elementKey];
                        delete itemsElements[mappedItemKey][elementKey]['element'];
                    }
                }
            }
            return itemsElements
        },
        settings: {
            getSettings: function () {
                return PTCProductBuilder.embroiderySettings;
            },
            getCurrentPositions: function () {
                const settings = this.getSettings();
                return settings.currentPositions;
            },
            getItemCurrentPositions: function (itemKey) {
                const currentPositions = this.getCurrentPositions();
                return currentPositions[itemKey] ?? false;
            },
            replaceItemPosition: function (itemKey, type, beforePosition, newPosition) {
                this.unsetItemPosition(itemKey, beforePosition);
                this.setItemPosition(itemKey, type, newPosition);
            },
            setItemPosition: function (itemKey, type, position) {
                let currentPositions = this.getCurrentPositions();
                if (!currentPositions[itemKey]) currentPositions[itemKey] = {};
                currentPositions[itemKey][position] = type
            },
            unsetItemPosition: function (itemKey, position) {
                const itemCurrentPositions = this.getItemCurrentPositions(itemKey);
                if (itemCurrentPositions) delete itemCurrentPositions[position];
            },
            getItemActions: function (itemKey, location = null) {
                const settings = this.getSettings();
                if (settings.itemActions.hasOwnProperty(itemKey)) {
                    if (location) {
                        return settings.itemActions[itemKey][location] ?? false;
                    }
                    return settings.itemActions[itemKey];
                }
                return false;
            },
            getItemAction: function (itemKey, location, type) {
                const settings = this.getItemActions(itemKey);
                if (settings && settings[location] && settings[location][type]) {
                    return settings[location][type];
                }
                return false;
            },
            unsetItemAction: function (itemKey, location, type) {
                const settings = this.getItemActions(itemKey);
                if (settings && settings[location] && settings[location][type]) {
                    delete settings[location][type];
                }
            },
            setItemAction: function (action, itemKey, location) {
                const settings = this.getSettings();
                const itemActions = settings.itemActions;
                itemActions[itemKey] = itemActions[itemKey] || {};
                itemActions[itemKey][location] = itemActions[itemKey][location] || {};
                itemActions[itemKey][location][action.type] = action;
            },
            getSpecificKeyFromItemAction: function (itemKey, location, type, key) {
                const itemActions = this.getItemActions(itemKey, location);
                if (!itemActions) return false;
                return itemActions[type] ? itemActions[type][key] : false;

            },
            getItemActionElement: function (itemKey, location, type) {
                return this.getSpecificKeyFromItemAction(itemKey, location, type, 'element');
            },
            getItemActionPosition: function (itemKey, location, type) {
                return this.getSpecificKeyFromItemAction(itemKey, location, type, 'position');
            }
        }
    }
}
